// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/unchecked.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/images/checked.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAA9hAAAPYQGoP6dpAAAAIGNIUk0AAHolAACAgwAA+f8AAIDoAABSCAABFVgAADqXAAAXb9daH5AAAALoSURBVHja7NlNiB1FEMDx39MoQRQjbDQHo+6grJqD+EEcD0oIUXMyBEHB4EFEnEBykiDJTUUhB8Gv4OQQvxEDKgh6MKsiXjIH8SoaGT/2EOOaL13BQ+R5qYVHM8/srsm8zTIFj0d3dc30f6aqurqn1+/3LQU5zxKRDqQD6UA6kA6kA+lAsOz/XiAva7gC63E3bsDlof4N3+IAvsSvqX1VZKMHyct6BbZgOyYahmTI8Qi+w0t4FycWjWvlZX0NXsMrQyBSmcCesLl6UYDkZT2O/di8APPNYTs+0hgJd3oZaxvUn0UsTKGPq7AOG5Jxt4ebPYQ/zwRIbz77kbyse3gcryaqKezCp5hOdCuxEc9idaLbir1VkfXbdq1VeCLp+xkP4J0GCNH3Nh7EL4lux0CGaxVkPa4daJ+KyVRzsD2IJ8NmMKvdMwqQe5P2F/Gbq0xGHA3KxlGA3NgwsaPzsD/aAHJdXtbntw2S+vOPC7jnT5HRZmUFlrcNkj65hWSbPnrJHHptg/yetK9cwD1Tm5P4u22Q75P2Olw6D/tLcGfSV1dFdqptkANJ+z7cMQ/7u7CpIWG0nrUmcSSJmeeidD+drMHTuCBJFh+PAmQKLyZ9N+OtqKeWDannNuAN3JLovsGx1mutqLfG8ElD0XgSH8Uqfzgy0arYj2waEkt/BeCuqsj+aBUkYG7Ce7h+yJCZ+L94jpf8ENuqIjvcKkjA3BYbpbVnaEvxFR6tiuyHVneIVZF9HS7zfLhV/zSL4JEo/w/+R0bbn5f1ra2+kWSPMoH7ozrOBlxqBjU+xwc4FO64L2KnSWoUVZFNtg2Sdl2GsYFK4HiD2Tj2xqnLsApia1Vk74/yXOt4PPlDQyBm148tkTCaZAxv5mX98ChB5irTeAwvDNFfhGfOBZDZGNqBnfinQX/huQIiCsbd8XZmEvXus3YcdJZg+ng9L+tpPBUxsgdla1lrsUj3WaED6UA6kA6kA+lAlhLIvwMAM2C/OO/NjgIAAAAASUVORK5CYII=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--style import constant--*/
/*--Fonts--*/
:root {
  --primary: #FF914E;
  --secondary: #07748F;
  --info: #343833;
  --white: #FFFFFF;
  --black: #000000;
  --liteblue: #e7f3f5;
  --shadeblue: #d1e6eb;
  --hrborder: #e4dede;
  --theader: #f5f7f8;
  --thinfo: #384648;
  --thborder: #dee2e6;
  --dlink: #007bff;
  --btninfo: #313232;
  --gary: #5a6e82;
  --high-to-low: linear-gradient(to right, #07748F 0%, #72B0C0 100%);
  --low-to-high: linear-gradient(90deg, #72B0C0 0, #07748F);
  --red: #f15e48;
  --green: #02681a;
  --lowgray: #A0B2B5;
}

/* ---- font family ----*/
/*--- pixels --- */
/*---font size---*/
/*---font weight---*/
/*--- percentage ---*/
/*--- display ---*/
/*--- alignment ---*/
/*--Position --*/
/*--- Text Transform ---*/
/*-- Text Style --*/
/*-- Info and paragraph --*/
.font-common {
  font-size: 14px;
  color: var(--info);
  font-weight: 600;
}

/*--Flex-box--*/
.w-flex {
  width: 100%;
  display: flex;
}

/*-- Form Label--*/
.input-fonts, .inputfields, .formlabel {
  font-size: 11px;
  color: var(--black);
}

.formlabel {
  opacity: 1;
  margin-bottom: 0.3rem;
  margin-top: 5px;
  font-weight: 500;
}

.login-btn-hover {
  color: var(--primary);
  background-position: left;
  fill: var(--primary) !important;
}

.heading-comman, .heading-4, .heading-3, .heading-2, .card-content h4, .banner-bg-content .banner-container .banner-content .smalltext, .heading-1, .banner-bg-content .banner-container .banner-content h1 {
  font-style: normal;
  font-weight: 700;
}

.heading-1, .banner-bg-content .banner-container .banner-content h1 {
  font-size: 43px;
  line-height: 62px;
  margin-bottom: 25px;
}

.heading-2, .card-content h4, .banner-bg-content .banner-container .banner-content .smalltext {
  font-size: 35px;
  line-height: 50px;
}

.heading-3 {
  font-size: 30px;
  line-height: 60px;
  margin-bottom: 15px;
}

.heading-4 {
  font-weight: 600;
  font-size: 25px;
  line-height: 26px;
}

.inputfields {
  height: 30px;
  line-height: 30px;
  opacity: 0.8;
  padding: 0px 0.5rem;
  background: #F4F6F7;
}

/*-- Box outer --*/
.boxing {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: var(--white);
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  padding: 15px 15px;
}

.login-btn-hover {
  color: var(--primary);
  background-position: left;
  fill: var(--primary) !important;
}

.heading-comman, .heading-1, .banner-bg-content .banner-container .banner-content h1, .heading-2, .card-content h4, .banner-bg-content .banner-container .banner-content .smalltext, .heading-3, .heading-4 {
  font-style: normal;
  font-weight: 700;
}

.heading-1, .banner-bg-content .banner-container .banner-content h1 {
  font-size: 43px;
  line-height: 62px;
  margin-bottom: 25px;
}

.heading-2, .card-content h4, .banner-bg-content .banner-container .banner-content .smalltext {
  font-size: 35px;
  line-height: 50px;
}

.heading-3 {
  font-size: 30px;
  line-height: 60px;
  margin-bottom: 15px;
}

/*--Buttons common--*/
.button-common, .secondary_button, .primary_button, .banner-bg-content .banner-container .banner-btn a {
  background: transparent !important;
  display: inline-block !important;
  padding: 8px 30px !important;
  height: 44px !important;
  border-radius: 50px !important;
  position: relative !important;
  transition: all 0.5s linear !important;
  text-align: center !important;
  vertical-align: middle !important;
  text-decoration: none !important;
  outline: 0px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 0px !important;
  cursor: pointer !important;
  text-transform: capitalize !important;
}

.link_button, .banner-bg-content .banner-container .banner-btn a {
  padding: 8px 40px !important;
  line-height: 1.5 !important;
  height: fit-content !important;
}

.primary, .secondary_button:hover, .primary_button, .banner-bg-content .banner-container .banner-btn a {
  border: 3px solid var(--primary) !important;
  background-color: var(--primary) !important;
  color: var(--white) !important;
  box-shadow: none !important;
}

.secondary, .secondary_button, .primary_button:hover, .banner-bg-content .banner-container .banner-btn a:hover {
  border: 3px solid var(--primary) !important;
  background-color: var(--primary) !important;
  color: var(--white) !important;
  box-shadow: none !important;
}

.stepper-next-btn:hover {
  border: 0px !important;
}

.primary_button span.MuiTouchRipple-root, .banner-bg-content .banner-container .banner-btn a span.MuiTouchRipple-root {
  display: none;
}

.secondary_button span.MuiTouchRipple-root {
  display: none;
}

.seeanalytics {
  padding: 8px 18px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  height: 33px !important;
}
.seeanalytics:hover, .seeanalytics:active, .seeanalytics:focus {
  background-color: var(--primary) !important;
}

.btn-wid, .banner-bg-content .banner-container .banner-btn a {
  padding: 10px 40px !important;
  margin-top: 25px;
  margin-right: 13px;
}

/* --banner-style-- */
.banner-bg-content .banner-container {
  padding-top: 30px;
  padding-bottom: 30px;
  min-height: 585px;
}
.banner-bg-content .banner-container .banner-content {
  padding: 0px;
  color: var(--white);
  font-style: normal;
}
.banner-bg-content .banner-container .banner-content .smalltext {
  font-weight: 600 !important;
  line-height: 68px !important;
  color: #07748f !important;
  margin-bottom: 0 !important;
  margin-top: 17px !important;
}
.banner-bg-content .banner-container .banner-content p {
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 1rem;
}
.banner-bg-content .banner-container .banner-img img {
  width: 119%;
  position: relative;
  top: -10px;
  left: 74px;
  height: auto;
}
.banner-bg-content .banner-container .banner-btn a {
  box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, 0.3);
}
.banner-bg-content .banner-container .banner-btn a:nth-child(2) {
  background-color: transparent !important;
  border: 2px solid var(--white) !important;
}
.banner-bg-content .banner-container .banner-btn a:hover {
  box-shadow: none;
}

/* -- card-style -- */
.card-content {
  background-color: rgba(7, 116, 143, 0.05);
}
.card-content h4 {
  margin-bottom: 40px;
}
.card-content .section-card {
  width: 100%;
  margin-left: auto;
  display: block;
  height: 105px;
  background: var(--white);
  box-shadow: 0 4px 20px rgba(23, 125, 150, 0.2);
  border-radius: 20px;
  padding: 10px 18px 10px 6px;
  margin-bottom: 25px;
  transition: all 0.5s ease-in-out;
  flex-direction: unset !important;
}
.card-content .section-card p {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 0;
  margin-left: 10px;
}
.card-content .section-card:hover {
  transform: scale(1.05);
  box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, 0.3) !important;
}

.btn-wid, .banner-bg-content .banner-container .banner-btn a {
  padding: 10px 40px !important;
  margin-top: 25px;
  margin-right: 13px;
}

/* --banner-style-- */
.banner-bg-content .banner-container {
  padding-top: 30px;
  padding-bottom: 30px;
  min-height: 585px;
}
.banner-bg-content .banner-container .banner-content {
  padding: 0px;
  color: var(--white);
  font-style: normal;
}
.banner-bg-content .banner-container .banner-content .smalltext {
  font-weight: 600 !important;
  line-height: 68px !important;
  color: #07748f !important;
  margin-bottom: 0 !important;
  margin-top: 17px !important;
}
.banner-bg-content .banner-container .banner-content p {
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 1rem;
}
.banner-bg-content .banner-container .banner-img img {
  width: 119%;
  position: relative;
  top: -10px;
  left: 74px;
  height: auto;
}
.banner-bg-content .banner-container .banner-btn a {
  box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, 0.3);
}
.banner-bg-content .banner-container .banner-btn a:nth-child(2) {
  background-color: transparent !important;
  border: 2px solid var(--white) !important;
}
.banner-bg-content .banner-container .banner-btn a:hover {
  box-shadow: none;
}

/* -- card-style -- */
.card-comman {
  background: #fff;
  box-shadow: 0 4px 40px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
}

.card-content {
  background-color: rgba(7, 116, 143, 0.05);
}
.card-content h4 {
  margin-bottom: 40px;
}
.card-content .section-card {
  width: 100%;
  margin-left: auto;
  display: block;
  height: 105px;
  background: var(--white);
  box-shadow: 0 4px 20px rgba(23, 125, 150, 0.2);
  border-radius: 20px;
  padding: 10px 18px 10px 6px;
  margin-bottom: 25px;
  transition: all 0.5s ease-in-out;
  flex-direction: unset !important;
}
.card-content .section-card .h-op-features {
  font-weight: 600 !important;
  margin-bottom: 5px !important;
}
.card-content .section-card p {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 0;
  margin-left: 10px;
}
.card-content .section-card:hover {
  transform: scale(1.05);
  box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, 0.3) !important;
}

* {
  margin: 0px;
  border: 0px;
  padding: 0px;
  outline: 0px;
  text-decoration: none;
  box-sizing: border-box;
  letter-spacing: normal !important;
  font-family: "Montserrat" !important;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/*--Body Style--*/
html {
  height: 100%;
}

body {
  margin: 0;
  font-family: "Montserrat" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100% !important;
  font-display: swap;
  font-weight: 400;
  line-height: 1.5;
}

/*-- Link txt SEO --*/
.hidden-link-txt {
  clip: rect(1px, 1px, 1px, 1px);
  word-wrap: normal !important;
  border: 0;
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute !important;
  width: 1px;
  word-break: normal;
}

/*-- Font Styles --*/
.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

.h3,
h3 {
  font-size: 1.75rem;
}

p {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 16px;
}

/*-- Forms Styles--*/
.MuiCheckbox-root {
  padding-right: 0px !important;
}
.MuiCheckbox-root svg {
  width: 16px;
  height: 16px;
}
.MuiCheckbox-root svg[data-testid=CheckBoxOutlineBlankIcon] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
}
.MuiCheckbox-root svg[data-testid=CheckBoxOutlineBlankIcon] path {
  display: none;
}
.MuiCheckbox-root svg[data-testid=CheckBoxIcon] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  color: transparent !important;
}

.MuiRadio-root svg {
  width: 17px;
  height: 17px;
}

.MuiRadio-root.Mui-checked {
  color: var(--primary) !important;
}

/*--Scroll bar style --*/
.hidden-scroll {
  overflow: auto !important;
}
.hidden-scroll::-webkit-scrollbar {
  width: 0px;
}

/* -- padding --*/
.p-0 {
  padding: 0px !important;
}

.p-10 {
  padding: 10px !important;
}

/* -- padding top --*/
.pt-18 {
  padding-top: 18px !important;
}

.pt-22 {
  padding-top: 22px !important;
}

.pt-40 {
  padding-top: 40px !important;
}

.pt-50 {
  padding-top: 50px !important;
}

.pt-70 {
  padding-top: 70px !important;
}

.pt-85 {
  padding-top: 85px !important;
}

/* -- padding bottom --*/
.pb-40 {
  padding-bottom: 40px !important;
}

.pb-50 {
  padding-bottom: 50px !important;
}

.pb-70 {
  padding-bottom: 70px !important;
}

.pb-85 {
  padding-bottom: 85px !important;
}

/* -- padding left --*/
.pl-5 {
  padding-left: 5px;
}

.pl-10 {
  padding-left: 10px;
}

.pl-15 {
  padding-left: 15px !important;
}

.pl-20 {
  padding-left: 20px !important;
}

.pl-30 {
  padding-left: 30px !important;
}

.pl-40 {
  padding-left: 40px !important;
}

.pl-45 {
  padding-left: 45px !important;
}

.pl-65 {
  padding-left: 65px !important;
}

/* -- padding right --*/
.pr-10 {
  padding-left: 10px;
}

.pr-15 {
  padding-right: 15px !important;
}

.pr-20 {
  padding-right: 20px !important;
}

.pr-30 {
  padding-right: 30px !important;
}

.pr-40 {
  padding-right: 40px !important;
}

.pr-45 {
  padding-right: 45px !important;
}

.pr-60 {
  padding-right: 60px !important;
}

.pr-75 {
  padding-right: 75px !important;
}

/* -- padding left right--*/
.plr-15 {
  padding-left: 15px !important;
  padding-right: 15px !important;
}

.plr-16 {
  padding-left: 16px !important;
  padding-right: 16px !important;
}

/* -- padding top bottom--*/
.ptb-3 {
  padding-top: 3px !important;
  padding-bottom: 3px !important;
}

.ptb-8 {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.plr-16 {
  padding-left: 16px !important;
  padding-right: 16px !important;
}

.ptb-8 {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

/* -- margin --*/
.m-auto {
  margin: auto !important;
}

.m-10 {
  margin: 10px !important;
}

.ml-0 {
  margin-left: 0px !important;
}

.ml-5 {
  margin-left: 5px !important;
}

.ml-10 {
  margin-left: 10px !important;
}

.ml-15 {
  margin-left: 15px;
}

.ml-20 {
  margin-left: 20px;
}

.ml-47 {
  margin-left: 47px !important;
}

.ml-200 {
  margin-left: 200px;
}

/* -- margin right--*/
.mr-0 {
  margin-right: 0px !important;
}

.mr-5 {
  margin-right: 5px !important;
}

.mr-10 {
  margin-right: 10px !important;
}

.mr-15 {
  margin-right: 15px !important;
}

/* -- margin top--*/
.mt-0 {
  margin-top: 0px !important;
}

.mt-3 {
  margin-top: 3px !important;
}

.mt-5 {
  margin-top: 5px !important;
}

.mt-8 {
  margin-top: 8px !important;
}

.mt-10 {
  margin-top: 10px !important;
}

.mt-15 {
  margin-top: 15px !important;
}

.mt-20 {
  margin-top: 20px !important;
}

.mt-30 {
  margin-top: 30px !important;
}

.mt-50 {
  margin-top: 50px !important;
}

.mt-70 {
  margin-top: 80px !important;
}

.mt-80 {
  margin-top: 80px !important;
}

/* -- margin bottom--*/
.mb-0 {
  margin-bottom: 0px !important;
}

.mb-5 {
  margin-bottom: 5px !important;
}

.mb-10 {
  margin-bottom: 10px !important;
}

.mb-12 {
  margin-bottom: 12px !important;
}

.mb-15 {
  margin-bottom: 15px !important;
}

.mb-30 {
  margin-bottom: 30px !important;
}

.mb-50 {
  margin-bottom: 50px !important;
}

.mb-60 {
  margin-bottom: 60px !important;
}

.mb-70 {
  margin-bottom: 70px !important;
}

/* -- margin top bottom */
.mtb-10 {
  margin-top: 10px;
  margin-bottom: 10px;
}

/* --height --*/
.h-32 {
  min-height: 32px !important;
}

/* -- width --*/
.w-fit {
  width: fit-content !important;
}

.w-18px {
  width: 18px;
}

.w-115px {
  width: 115px;
}

.w-200px {
  width: 200px !important;
}

.w-250px {
  width: 250px !important;
}

.h-280px {
  height: 280px !important;
}

.h-250px {
  height: 205px !important;
}

.w-100 {
  width: 100%;
}

.w-90 {
  width: 90%;
}

.w-60 {
  width: 60% !important;
}

.w-50 {
  width: 50% !important;
}

.w-55 {
  width: 55%;
}

.w-40 {
  width: 40% !important;
}

.w-45 {
  width: 45%;
}

/* -- text-center --*/
.text-center {
  text-align: center !important;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

/* -- display --*/
.d-block {
  display: block !important;
}

.d-flex {
  display: flex !important;
}

.d-grid {
  display: grid !important;
}

.d-none {
  display: none !important;
}

/* -- justify content */
.justyfy-center {
  justify-content: center !important;
}

.justyfy-left {
  justify-content: left !important;
}

.justyfy-right {
  justify-content: right !important;
}

.justyfy-space-between {
  justify-content: space-between !important;
}

.justyfy-end {
  justify-content: end !important;
}

/*-- Positions--*/
.p-absolute {
  position: absolute;
}

/* --- align item --*/
.align-top {
  align-items: top;
}

.align-center {
  align-items: center;
}

/*-- Cursor pointer --*/
.cursor-p {
  cursor: pointer;
}

.cursor-d {
  cursor: default;
}

.cursor-d,
.cursor-d input[type=checkbox],
.cursor-d svg {
  pointer-events: visible !important;
  cursor: not-allowed !important;
}

/*--Flex-dirction--*/
.flexdirection-col {
  flex-direction: column !important;
}

/*-- ToolTip --*/
div[role=tooltip] .MuiTooltip-tooltip {
  padding: 6px 7px 6px 9px;
  background: var(--black);
  color: #fff;
  opacity: 1;
  z-index: 999;
  min-width: 80%;
  max-width: 100%;
}
div[role=tooltip] .MuiTooltip-tooltip .table-tooltip {
  width: max-content;
}
div[role=tooltip] .MuiTooltip-tooltip .table-tooltip .column-2 {
  columns: 2 !important;
}
div[role=tooltip] .MuiTooltip-tooltip .table-tooltip .column-3 {
  columns: 3 !important;
}
div[role=tooltip] .MuiTooltip-tooltip .table-tooltip .column-4 {
  columns: 4 !important;
}
div[role=tooltip] .MuiTooltip-tooltip .table-tooltip .ul,
div[role=tooltip] .MuiTooltip-tooltip .table-tooltip li {
  list-style: none !important;
}
div[role=tooltip] .MuiTooltip-tooltip .table-tooltip p {
  margin-bottom: 1px;
  font-weight: 500;
  color: var(--white);
  font-size: 10px;
  line-height: 20px;
  align-items: center;
  display: flex;
}
div[role=tooltip] .MuiTooltip-tooltip .table-tooltip p span {
  width: 150px;
  display: inline-block;
  font-weight: 400;
}
div[role=tooltip] .MuiTooltip-tooltip .paratooltip p {
  margin-bottom: 1px;
  font-weight: 500;
  color: var(--white);
  font-size: 10px;
  line-height: 20px;
  align-items: center;
  width: 300px !important;
}
div[role=tooltip] .MuiTooltip-tooltip .MuiTooltip-arrow {
  color: var(--black);
}

/*-- Background Colors--*/
.background-blue {
  background: var(--liteblue);
}

/*-- error txt --*/
.err {
  font-size: 10px !important;
  color: #f15d48 !important;
  margin-bottom: 0px !important;
}

.Mui-error {
  font-size: 11px !important;
  color: #f15d47 !important;
  opacity: 1 !important;
}

/* -- select drop down */
.menus-container,
.MuiAutocomplete-popper {
  max-width: 300px !important;
  opacity: 1 !important;
}

.MuiPopper-root[data-popper-placement=bottom-start]:not(.MuiTooltip-popper),
.MuiPopper-root[data-popper-placement=top-start]:not(.MuiTooltip-popper),
.MuiPopper-root[data-popper-placement=bottom-end]:not(.MuiTooltip-popper),
.base-Popper-root[data-popper-placement=bottom-start]:not(.MuiTooltip-popper),
.base-Popper-root[data-popper-placement=top-start]:not(.MuiTooltip-popper),
.base-Popper-root[data-popper-placement=bottom-end]:not(.MuiTooltip-popper) {
  font-size: 12px !important;
  max-width: 172px;
  overflow-y: auto !important;
  font-weight: 300 !important;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2509803922);
  border: 1px solid #D9E2E5;
  border-radius: 8px !important;
  z-index: 99999999999 !important;
  overflow-x: hidden !important;
  width: 100%;
  max-height: 15rem;
  background-color: var(--white);
}
.MuiPopper-root[data-popper-placement=bottom-start]:not(.MuiTooltip-popper) .route-search,
.MuiPopper-root[data-popper-placement=top-start]:not(.MuiTooltip-popper) .route-search,
.MuiPopper-root[data-popper-placement=bottom-end]:not(.MuiTooltip-popper) .route-search,
.base-Popper-root[data-popper-placement=bottom-start]:not(.MuiTooltip-popper) .route-search,
.base-Popper-root[data-popper-placement=top-start]:not(.MuiTooltip-popper) .route-search,
.base-Popper-root[data-popper-placement=bottom-end]:not(.MuiTooltip-popper) .route-search {
  padding: 10px;
  position: sticky;
  z-index: 9999;
  top: 0px;
  background: #fff;
}
.MuiPopper-root[data-popper-placement=bottom-start]:not(.MuiTooltip-popper) .route-search input[type=text],
.MuiPopper-root[data-popper-placement=top-start]:not(.MuiTooltip-popper) .route-search input[type=text],
.MuiPopper-root[data-popper-placement=bottom-end]:not(.MuiTooltip-popper) .route-search input[type=text],
.base-Popper-root[data-popper-placement=bottom-start]:not(.MuiTooltip-popper) .route-search input[type=text],
.base-Popper-root[data-popper-placement=top-start]:not(.MuiTooltip-popper) .route-search input[type=text],
.base-Popper-root[data-popper-placement=bottom-end]:not(.MuiTooltip-popper) .route-search input[type=text] {
  width: 100%;
  height: 30px;
  line-height: 30px;
  opacity: 0.8;
  border: 1px solid #F4F6F7;
  border-radius: 8px !important;
  background-color: #F4F6F7 !important;
  background-repeat: no-repeat;
  background-position: 0;
  padding: 8px;
  background-size: 26px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  padding-left: 30px;
}
.MuiPopper-root[data-popper-placement=bottom-start]:not(.MuiTooltip-popper) li,
.MuiPopper-root[data-popper-placement=top-start]:not(.MuiTooltip-popper) li,
.MuiPopper-root[data-popper-placement=bottom-end]:not(.MuiTooltip-popper) li,
.base-Popper-root[data-popper-placement=bottom-start]:not(.MuiTooltip-popper) li,
.base-Popper-root[data-popper-placement=top-start]:not(.MuiTooltip-popper) li,
.base-Popper-root[data-popper-placement=bottom-end]:not(.MuiTooltip-popper) li {
  font-size: 12px;
  white-space: break-spaces;
  z-index: 999 !important;
}
.MuiPopper-root[data-popper-placement=bottom-start]:not(.MuiTooltip-popper) li:hover,
.MuiPopper-root[data-popper-placement=top-start]:not(.MuiTooltip-popper) li:hover,
.MuiPopper-root[data-popper-placement=bottom-end]:not(.MuiTooltip-popper) li:hover,
.base-Popper-root[data-popper-placement=bottom-start]:not(.MuiTooltip-popper) li:hover,
.base-Popper-root[data-popper-placement=top-start]:not(.MuiTooltip-popper) li:hover,
.base-Popper-root[data-popper-placement=bottom-end]:not(.MuiTooltip-popper) li:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
.MuiPopper-root[data-popper-placement=bottom-start]:not(.MuiTooltip-popper) li:focus, .MuiPopper-root[data-popper-placement=bottom-start]:not(.MuiTooltip-popper) li:active, .MuiPopper-root[data-popper-placement=bottom-start]:not(.MuiTooltip-popper) li:focus-visible,
.MuiPopper-root[data-popper-placement=top-start]:not(.MuiTooltip-popper) li:focus,
.MuiPopper-root[data-popper-placement=top-start]:not(.MuiTooltip-popper) li:active,
.MuiPopper-root[data-popper-placement=top-start]:not(.MuiTooltip-popper) li:focus-visible,
.MuiPopper-root[data-popper-placement=bottom-end]:not(.MuiTooltip-popper) li:focus,
.MuiPopper-root[data-popper-placement=bottom-end]:not(.MuiTooltip-popper) li:active,
.MuiPopper-root[data-popper-placement=bottom-end]:not(.MuiTooltip-popper) li:focus-visible,
.base-Popper-root[data-popper-placement=bottom-start]:not(.MuiTooltip-popper) li:focus,
.base-Popper-root[data-popper-placement=bottom-start]:not(.MuiTooltip-popper) li:active,
.base-Popper-root[data-popper-placement=bottom-start]:not(.MuiTooltip-popper) li:focus-visible,
.base-Popper-root[data-popper-placement=top-start]:not(.MuiTooltip-popper) li:focus,
.base-Popper-root[data-popper-placement=top-start]:not(.MuiTooltip-popper) li:active,
.base-Popper-root[data-popper-placement=top-start]:not(.MuiTooltip-popper) li:focus-visible,
.base-Popper-root[data-popper-placement=bottom-end]:not(.MuiTooltip-popper) li:focus,
.base-Popper-root[data-popper-placement=bottom-end]:not(.MuiTooltip-popper) li:active,
.base-Popper-root[data-popper-placement=bottom-end]:not(.MuiTooltip-popper) li:focus-visible {
  background-color: rgb(217, 226, 229) !important;
  color: #384648 !important;
}

.MuiPopper-root[id=simple-popper],
.base-Popper-root[id=simple-popper] {
  font-size: 12px !important;
  max-width: fit-content !important;
  overflow-y: auto !important;
  font-weight: 300 !important;
  border-bottom-left-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
  z-index: 2 !important;
  overflow-x: hidden !important;
  width: 200px;
  margin-top: 7px !important;
  padding: 3px 15px 5px;
  margin-left: -26px !important;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.5) !important;
  background-color: var(--white);
}
.MuiPopper-root[id=simple-popper] button,
.base-Popper-root[id=simple-popper] button {
  font-size: 13px;
  font-weight: 500;
  line-height: 33px;
  height: 33px;
  margin-top: 5px;
  padding: 5px 10px;
  border-radius: 5px;
  transition: all 0.5s linear;
  box-shadow: none !important;
  background: transparent !important;
  color: #07748f;
  border: none !important;
  text-transform: capitalize;
  justify-content: flex-start !important;
}
.MuiPopper-root[id=simple-popper] button span,
.base-Popper-root[id=simple-popper] button span {
  font-size: 16px;
  margin-right: 5px;
}
.MuiPopper-root[id=simple-popper] button:hover,
.base-Popper-root[id=simple-popper] button:hover {
  background-color: var(--primary) !important;
  color: var(--white);
}

.MuiPaper-elevation.MuiMenu-paper {
  max-height: 250px !important;
  max-width: 280px !important;
}
.MuiPaper-elevation.MuiMenu-paper ul li {
  font-size: 12px;
  padding: 2px 10px;
  font-weight: 500;
}
.MuiPaper-elevation.MuiMenu-paper ul li em {
  font-style: normal !important;
}

/*-- Table --*/
.MuiTablePagination-selectLabel,
.MuiTablePagination-displayedRows {
  margin-bottom: 0px;
}

#webpack-dev-server-client-overlay {
  display: none !important;
}

.scrolling-text-container {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  height: 40px;
  display: flex;
  align-items: center;
}

.ac-status-bar {
  animation: scrollText 25s linear infinite;
}

@keyframes scrollText {
  0% {
    transform: translateX(185%);
  }
  100% {
    transform: translateX(-100%);
  }
}
/* Add this to your CSS or use a CSS-in-JS solution like styled-components */
.toggle-switch {
  display: inline-block;
  position: relative;
  width: 34px;
  height: 18px;
}

.toggle-switch input {
  display: none;
}

.yesorno {
  color: #7b7b7b;
  font-weight: 400;
  position: relative;
  top: -3px;
  font-size: 13px;
  padding-left: 10px;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #888;
  transition: 0.4s;
  border-radius: 30px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input[type=checkbox].custom-checkbox,
input[type=checkbox] {
  width: 16px;
  height: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  background-size: contain;
  background-repeat: no-repeat;
  outline: none !important;
  cursor: pointer !important;
  border: none;
  appearance: none;
  /* Remove default checkbox appearance */
}

input[type=checkbox].custom-checkbox:checked,
input[type=checkbox]:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer !important;
}

input:checked + .slider {
  background-color: var(--primary);
}

input:checked + .slider:before {
  transform: translateX(17px);
}

.spin {
  animation-name: spin;
  animation-duration: 4000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

button.loginbtn {
  align-items: center;
  display: flex !important;
}
button.loginbtn svg {
  margin-right: 5px;
}
button.loginbtn:disabled {
  opacity: 1 !important;
}

.stepper-btn button.secondary_button.clear-background {
  background: transparent !important;
  color: #313232 !important;
  border: 1px solid #313232 !important;
  margin-right: 15px !important;
}
.stepper-btn button.secondary_button.clear-background:hover, .stepper-btn button.secondary_button.clear-background:active, .stepper-btn button.secondary_button.clear-background:focus {
  color: #fff !important;
  background-color: #545b62 !important;
  border-color: #4e555b !important;
}

button:disabled {
  opacity: 0.6;
}

.css-12i7wg6-MuiPaper-root-MuiDrawer-paper {
  z-index: 2 !important;
}

.no-data-availabe {
  color: #f15d48 !important;
  font-size: 13px;
}

.err-txt {
  font-size: 11px !important;
  font-weight: 400 !important;
  line-height: 1.66 !important;
  color: red !important;
}

.color-red {
  color: red;
}

.input-common {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

input::placeholder {
  font-size: 12px !important;
  color: currentColor;
  opacity: 1;
}

#play-btns {
  background: #5a6e82 !important;
  color: #fff !important;
  font-size: 10px !important;
  padding: 4px 5px !important;
}
#play-btns img {
  margin-right: 6px;
}
#play-btns span {
  position: relative;
  top: 1px;
}

input[type=time] {
  position: relative;
}

input[type=time]::-webkit-calendar-picker-indicator {
  display: block;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  position: absolute;
  background: transparent;
}

.MuiPopper-root[role=dialog],
.base-Popper-root[role=dialog] {
  max-width: 113px !important;
  display: inline-block;
  position: relative;
  outline: none;
  list-style: none;
  font-size: 12px;
  text-align: left;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 5px #ccc;
  background-clip: padding-box;
  border: 1px solid #ccc;
  line-height: 1.5;
}
.MuiPopper-root[role=dialog] .MuiPickersLayout-contentWrapper .MuiMultiSectionDigitalClock-root ul,
.base-Popper-root[role=dialog] .MuiPickersLayout-contentWrapper .MuiMultiSectionDigitalClock-root ul {
  float: left;
  font-size: 12px;
  border: 1px solid #e9e9e9;
  border-width: 0 1px;
  margin-left: -1px;
  box-sizing: border-box;
  width: 56px;
  max-height: 170px;
  overflow-y: auto;
  position: relative;
}
.MuiPopper-root[role=dialog] .MuiPickersLayout-contentWrapper .MuiMultiSectionDigitalClock-root ul li,
.base-Popper-root[role=dialog] .MuiPickersLayout-contentWrapper .MuiMultiSectionDigitalClock-root ul li {
  padding-left: 0px !important;
  padding-right: 0px !important;
  width: 100% !important;
  margin: 0px !important;
  height: 24px !important;
}
.MuiPopper-root[role=dialog] .MuiPickersLayout-contentWrapper .MuiMultiSectionDigitalClock-root ul li:hover,
.base-Popper-root[role=dialog] .MuiPickersLayout-contentWrapper .MuiMultiSectionDigitalClock-root ul li:hover {
  background-color: hsl(210, 77%, 46%) !important;
  color: #fff !important;
}
.MuiPopper-root[role=dialog] .MuiPickersLayout-contentWrapper .MuiMultiSectionDigitalClock-root ul .Mui-selected,
.base-Popper-root[role=dialog] .MuiPickersLayout-contentWrapper .MuiMultiSectionDigitalClock-root ul .Mui-selected {
  background-color: rgb(217, 226, 229) !important;
  color: #384648 !important;
  font-weight: 700;
}
.MuiPopper-root[role=dialog] .MuiPickersLayout-contentWrapper .MuiMultiSectionDigitalClock-root ul::after,
.base-Popper-root[role=dialog] .MuiPickersLayout-contentWrapper .MuiMultiSectionDigitalClock-root ul::after {
  height: fit-content !important;
}
.MuiPopper-root[role=dialog] .MuiPickersLayout-actionBar,
.base-Popper-root[role=dialog] .MuiPickersLayout-actionBar {
  display: none;
}

.input-time-picker input,
.input-time-picker button,
.input-time-picker fieldset {
  display: none !important;
}

button.MuiButtonBase-root span.MuiTouchRipple-root {
  display: none !important;
}

.MuiMenu-root.MuiPopover-root[id=menu-] .MuiPaper-elevation.MuiMenu-paper::-webkit-scrollbar {
  width: 4px;
}
.MuiMenu-root.MuiPopover-root[id=menu-] .MuiPaper-elevation.MuiMenu-paper::-webkit-scrollbar-track {
  background: rgba(255, 146, 78, 0.2196078431);
}
.MuiMenu-root.MuiPopover-root[id=menu-] .MuiPaper-elevation.MuiMenu-paper::-webkit-scrollbar-thumb {
  background: #07748F;
}
.MuiMenu-root.MuiPopover-root[id=menu-] .MuiPaper-elevation.MuiMenu-paper::-webkit-scrollbar-thumb:hover {
  background: #07748F;
  cursor: pointer;
}

/*--other common classnames--*/
.extraction-cls {
  cursor: pointer;
  color: blue;
}

.view-shop-table-class {
  overflow-x: auto;
  max-height: 400px;
  margin: auto;
  width: 50vw;
}

.max-height-table {
  overflow-y: scroll;
  max-height: 400px;
}

.grey-clr {
  color: #5a6e7f;
}

button,
a {
  cursor: pointer !important;
}

div[style="opacity: 1; transform: none; transition: opacity 271ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 180ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;"] {
  transition: none !important;
}

.Mui-selected {
  background-color: rgb(217, 226, 229) !important;
  color: #384648 !important;
}

.name-check {
  display: flex;
  align-items: center;
  width: 100%;
}
.name-check span {
  padding-top: 2px !important;
  padding-right: 3px !important;
  padding-bottom: 0px !important;
  top: 2px !important;
}
.name-check .check-dots {
  font-size: 20px !important;
  width: 70%;
  height: 30px !important;
  text-align: center !important;
  font-weight: 400 !important;
  color: #000000 !important;
}

.shopname-tooltip-btn {
  color: #000000 !important;
  text-decoration: none;
  background-color: transparent;
  font-size: 14px !important;
  word-break: break-all;
  font-weight: 400 !important;
  text-transform: none !important;
}

#dashboardmenulist .MuiTooltip-tooltip {
  opacity: 1;
}

#shopdetailstooltip,
#dashboardmenulist {
  z-index: 1299 !important;
}
#shopdetailstooltip .MuiTooltip-tooltip,
#dashboardmenulist .MuiTooltip-tooltip {
  width: 100% !important;
  max-width: 100%;
  background: transparent;
  margin: 0px !important;
}

.Shop-details {
  display: block !important;
}

.Shop-details {
  min-height: fit-content !important;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2509803922) !important;
  border: 1px solid #D9E2E5;
  border-radius: 8px !important;
  width: 320px;
  background-color: #fff;
  padding: 10px;
}
.Shop-details li {
  font-size: 12px !important;
  color: rgba(0, 0, 0, 0.8705882353);
  z-index: -1;
  display: flex;
}
.Shop-details li span {
  width: 50%;
}
.Shop-details li .callcount-value {
  overflow: visible;
}
.Shop-details li .callcount-unavailable-row {
  display: flex;
  align-items: center;
  gap: 6px;
  width: auto;
}
.Shop-details li .callcount-unavailable-text {
  color: #d32f2f;
  width: 90px;
}
.Shop-details li .callcount-retry-btn {
  flex-shrink: 0;
  width: auto;
  color: #1976d2;
  cursor: pointer;
  text-decoration: underline;
  font-weight: 600;
  font-size: 11px;
  white-space: nowrap;
}
.Shop-details li .callcount-retry-btn.retrying {
  opacity: 0.6;
  pointer-events: none;
}
.Shop-details button {
  width: 100%;
  padding: 8px !important;
  border-radius: 8px !important;
  margin-top: 8px !important;
  font-size: 12px !important;
  text-transform: capitalize !important;
  font-weight: 600 !important;
  color: #2E3D40 !important;
}
.Shop-details .log-btn {
  background-color: #E4EAEB !important;
  border: 1px solid #A0B2B5 !important;
}
.Shop-details .edit-btn {
  background-color: #A6C4CB !important;
  border: 1px solid #055061 !important;
}

.backgroundchange li:hover {
  background-color: #D9E2E5 !important;
  color: #000 !important;
}
.backgroundchange li:hover img {
  filter: brightness(0) !important;
}

.action-btns-box {
  max-height: 13rem !important;
  min-height: fit-content !important;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2509803922) !important;
  border: 1px solid #D9E2E5;
  border-radius: 8px !important;
  background-color: #fff;
}
.action-btns-box li {
  font-size: 12px !important;
  color: rgba(0, 0, 0, 0.8705882353);
  z-index: 2;
  position: relative;
}
.action-btns-box li img {
  margin-right: 5px;
  width: 14px;
}
.action-btns-box li:hover {
  background-color: rgba(0, 0, 0, 0.04);
  color: rgba(0, 0, 0, 0.8705882353);
  border-radius: 8px !important;
}
.action-btns-box li:hover img {
  filter: brightness(0);
}

.dot-check,
.shop-info {
  position: relative;
}
.dot-check .action-btns-box,
.shop-info .action-btns-box {
  display: block;
  position: relative;
  z-index: 1;
}
.dot-check .active-action-btns-box,
.shop-info .active-action-btns-box {
  display: block;
}

.MuiDrawer-paperAnchorDockedLeft {
  z-index: 2 !important;
}

svg.minus-svg {
  width: 16px;
  margin-right: 3px;
  color: #2E3D40;
  height: 18px;
}

.flex-box-button {
  display: flex;
  align-items: center;
}
.flex-box-button button {
  padding: 6px 10px;
  border-radius: 4px;
  background-color: var(--primary);
  color: #fff;
  margin-left: 10px;
}

span.no-options-found {
  font-size: 12px;
  padding: 2px 10px 0px;
  font-weight: 500;
}

.libraryerror {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  color: var(--primary);
}

.name-check span.align-item-cs {
  position: relative;
  top: -5px !important;
}

#menu-outputtype.MuiMenu-root,
#menu-pos.MuiMenu-root,
#menu-currency.MuiMenu-root,
.date-field-css,
#menu-source.MuiMenu-root,
#menu-routetype.MuiMenu-root,
#menu-status.MuiMenu-root,
#menu-group.MuiMenu-root,
#menu-cabinclass.MuiMenu-root {
  cursor: pointer !important;
}

.MuiOutlinedInput-notchedOutline {
  border: 0px solid #F4F6F7 !important;
}

.dontselect {
  pointer-events: none;
}

.overhidden {
  overflow: visible !important;
}

.customwidthrestrick {
  width: initial !important;
}

.passwordshow {
  position: relative;
}
.passwordshow input {
  position: relative;
  z-index: 1;
  padding: 6px 28px 6px 6px;
}
.passwordshow span.visibleeye {
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  text-align: center;
  position: absolute;
  z-index: 1;
  top: 7px;
  right: 10px;
  color: var(--lowgray) !important;
}
.passwordshow span.visibleeye svg {
  font-size: 16px;
}

.indiana-scroll-container {
  overflow-y: hidden;
  scroll-behavior: smooth;
  /* width */
}
.indiana-scroll-container::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  cursor: pointer;
}
.indiana-scroll-container {
  /* Track */
}
.indiana-scroll-container::-webkit-scrollbar-track {
  background: #ffffff;
  cursor: pointer;
}
.indiana-scroll-container {
  /* Handle */
}
.indiana-scroll-container::-webkit-scrollbar-thumb {
  background: #A0B2B5;
  cursor: pointer;
}
.indiana-scroll-container {
  /* Handle on hover */
}
.indiana-scroll-container::-webkit-scrollbar-thumb:hover {
  background: #A0B2B5;
}

.reset-pass p {
  display: flex;
  align-items: center;
}
.reset-pass p svg {
  margin-right: 3px;
  width: 18px;
  height: 18px;
}

.icons-svg-cs {
  width: 12px !important;
  height: 12px !important;
  margin-left: 5px;
  cursor: pointer;
}

#tableau-viz iframe {
  overflow-clip-margin: content-box !important;
  overflow: clip !important;
}

#tableau-viz,
#tableau-viz:hover,
#tableau-viz iframe,
#tableau-viz iframe:hover {
  overflow-y: hidden !important;
  overflow-x: hidden !important;
  justify-content: center !important;
}

#tableau-viz::-webkit-scrollbar,
#tableau-viz iframe::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

/* Track */
#tableau-viz::-webkit-scrollbar,
#tableau-viz iframe::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgb(255, 255, 255);
  border-radius: 0px;
}

/* Handle */
#tableau-viz::-webkit-scrollbar,
#tableau-viz iframe::-webkit-scrollbar-thumb {
  background: red;
  border-radius: 10px;
}

/* Handle on hover */
#tableau-viz::-webkit-scrollbar,
#tableau-viz iframe::-webkit-scrollbar-thumb:hover {
  background: #b30000;
}

.disabled-actions {
  pointer-events: none !important;
}

.required-modal .create-dashboard-modal {
  width: 35% !important;
}
.required-modal .create-dashboard-modal .dashboard-review-details {
  padding: 8px 0px 16px !important;
}
.required-modal .create-dashboard-modal .dashboard-review-table {
  min-height: 330px;
  max-height: 330px;
  overflow: auto;
}
.required-modal .create-dashboard-modal .dashboard-review-table th {
  border: none !important;
}
.required-modal .create-dashboard-modal .dashboard-review-table th:nth-child(1) {
  width: 25% !important;
}
.required-modal .create-dashboard-modal .dashboard-review-table th:nth-child(2) {
  width: 20% !important;
}
.required-modal .create-dashboard-modal .dashboard-review-table th:nth-child(3) {
  width: 30% !important;
}
.required-modal .create-dashboard-modal .dashboard-review-table::-webkit-scrollbar {
  width: 7px;
}
.required-modal .create-dashboard-modal .dashboard-review-table::-webkit-scrollbar-track {
  background: #ffffff;
  border-radius: 5px;
  border: 1px solid #D9E2E5;
  padding: 0px 5px;
}
.required-modal .create-dashboard-modal .dashboard-review-table::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #9b9a9a;
}
.required-modal .create-dashboard-modal .dashboard-review-table::-webkit-scrollbar-thumb:hover {
  background: #999;
}
.required-modal .create-dashboard-modal .required-select {
  border: 2px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  margin: 0px 5px;
  padding: 3px 0px;
  width: fit-content;
}

.create-dashboard-modal {
  width: 922px !important;
}
.create-dashboard-modal input[type=text] {
  width: 100%;
  height: 30px;
  line-height: 30px;
  opacity: 0.8;
  padding-right: 0.5rem;
  border: 1px solid #F4F6F7;
  border-radius: 8px !important;
  background-color: #F4F6F7 !important;
  background-repeat: no-repeat;
  background-position: 0;
  padding-left: 30px;
  background-size: 26px;
  margin-bottom: 15px;
}
.create-dashboard-modal h3 {
  margin-bottom: 0px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
}
.create-dashboard-modal h4,
.create-dashboard-modal h5 {
  margin-bottom: 8px !important;
  font-size: 14px !important;
  font-weight: 600;
  color: #1C1C1C;
  opacity: 0.5 !important;
}
.create-dashboard-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center !important;
  margin-bottom: 5px;
}
.create-dashboard-modal .modal-header button {
  line-height: normal;
  padding: 0px;
  height: fit-content;
  min-width: fit-content;
  font-size: 25px;
  transform: rotate(45deg);
}
.create-dashboard-modal .modal-header button:hover {
  background-color: transparent !important;
}
.create-dashboard-modal .add-dashboard-form {
  width: 100%;
}
.create-dashboard-modal .add-dashboard-form .library-list {
  height: 150px;
  overflow-y: auto;
  border: 1px solid #D9E2E5;
  border-radius: 8px;
  padding: 10px !important;
  background-color: #f6f8f9;
  margin-bottom: 0px;
}
.create-dashboard-modal .add-dashboard-form .library-list::-webkit-scrollbar {
  width: 7px;
}
.create-dashboard-modal .add-dashboard-form .library-list::-webkit-scrollbar-track {
  background: #ffffff;
  border-radius: 5px;
  border: 1px solid #D9E2E5;
  padding: 0px 5px;
}
.create-dashboard-modal .add-dashboard-form .library-list::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #9b9a9a;
}
.create-dashboard-modal .add-dashboard-form .library-list::-webkit-scrollbar-thumb:hover {
  background: #999;
}
.create-dashboard-modal .add-dashboard-form .library-list .w-200 {
  width: 16.5% !important;
}
.create-dashboard-modal .add-dashboard-form .library-list .pagination-page {
  padding: 0px 8px !important;
}
.create-dashboard-modal .add-dashboard-form .library-list ul li {
  list-style: none;
}
.create-dashboard-modal .add-dashboard-form .library-list ul li label {
  font-size: 14px;
  cursor: pointer;
}
.create-dashboard-modal .group-submit-btn {
  background-color: #FFA26E !important;
  border: 1px solid #FFA26E !important;
  outline: none !important;
  font-size: 14px;
  font-weight: 700;
  width: 100%;
  padding: 4px 8px;
  border-radius: 8px;
  color: #fff;
  margin-top: 10px;
}

.center-success-modal .modal-box {
  margin-top: auto !important;
  width: 450px !important;
  height: 235px !important;
  text-align: center;
  border-radius: 30px;
}
.center-success-modal h3 {
  text-align: center;
  font-size: 24px !important;
  font-weight: 600;
  color: var(--info);
}
.center-success-modal p {
  text-align: center !important;
  margin-top: 20px;
  margin-bottom: 20px;
  color: var(--info);
}
.center-success-modal .away-btn {
  cursor: pointer;
  background-color: transparent;
  font-size: 14px;
}
.center-success-modal .away-btn:hover, .center-success-modal .away-btn:focus, .center-success-modal .away-btn:active {
  background-color: transparent;
  font-size: 14px;
}

.icon-thunder {
  height: 21px;
  position: relative;
  top: 3px;
}

.btn-donload-reports {
  border-radius: 5px !important;
  margin-left: 10px;
  font-size: 13px !important;
  border: 3px solid var(--primary) !important;
  background-color: var(--primary) !important;
  color: var(--white) !important;
  box-shadow: none !important;
  padding: 14px 30px !important;
  position: relative !important;
  transition: all 0.5s linear !important;
  text-align: center !important;
  vertical-align: middle !important;
  text-decoration: none !important;
  outline: 0px !important;
  font-weight: 600 !important;
  line-height: 0px !important;
  cursor: pointer !important;
  text-transform: capitalize !important;
}

.disabled-btn-pointer {
  opacity: 0.7;
  cursor: not-allowed !important;
}

.disabled-btn-pointer:disabled {
  cursor: not-allowed !important;
}

button.hidedots {
  display: none !important;
}

.add-swap-btn {
  background: #07748F;
  text-transform: none;
  padding: 0 30px;
  font-weight: 400;
  font-size: 14px;
  border: none;
  border-radius: 2px;
  height: 35px;
  line-height: 35px;
  box-shadow: none !important;
  transition: all 0.5s linear;
  margin-right: 17px !important;
}

#seeoverview {
  flex-direction: row;
  align-items: center;
}
#seeoverview .tableau-dropdown {
  width: 350px !important;
  border: none !important;
  margin-right: 15px !important;
  padding: 0px !important;
  min-height: fit-content !important;
  max-height: fit-content !important;
  height: fit-content;
}

.see-link {
  font-size: 14px;
  font-weight: 400;
  text-decoration: underline;
  color: var(--secondary);
  cursor: pointer;
  width: fit-content !important;
}

.custom-select__option--is-focused {
  background-color: #fff2eb !important;
}

.custom-select__option--is-selected {
  background-color: #FFA26E !important;
  color: white;
}

.custom-select__control--is-focused {
  border-color: transparent !important;
}

.custom-select__control--is-focused {
  border-color: transparent !important;
  /* Remove the border when focused */
  box-shadow: 0 0 0 1px !important;
  /* Remove the shadow effect when focused */
}

.dropdown-menu {
  color: #fff;
  cursor: pointer;
  position: relative;
  text-align: center;
  text-decoration: none;
  z-index: 1;
  transform: perspective(1000px);
}

.dropdown-menu-item {
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2509803922) !important;
  border: 1px solid #D9E2E5;
  border-radius: 8px !important;
  background-color: #fff;
  list-style-type: none;
  margin: 0;
  opacity: 1;
  visibility: visible;
  padding: 5px 10px;
  cursor: pointer;
  transition: all 0.5s, background 2s 0.5s linear;
}

.dropdown-menu-item li {
  cursor: pointer;
  padding: 4px 0px;
}
.dropdown-menu-item li label {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.8705882353) !important;
}
.dropdown-menu-item li label input {
  margin-right: 5px;
}
.dropdown-menu-item li:hover {
  background-color: transparent !important;
  color: rgba(0, 0, 0, 0.8705882353) !important;
}

.dropdown-menu:hover .dropdown-menu-item {
  opacity: 1;
  visibility: visible;
  padding: 5px 10px;
  cursor: pointer;
  transition: all 0.5s, background 2s 0.5s linear;
}

.menu-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.menu-center span {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.menu-center span img {
  margin-right: 5px !important;
}
.menu-center img {
  margin-right: 0px !important;
}
.menu-center .scroll-list {
  max-height: 200px;
  overflow: auto;
  cursor: pointer;
}
.menu-center .scroll-list::-webkit-scrollbar {
  width: 4px;
}
.menu-center .scroll-list {
  /* Track */
}
.menu-center .scroll-list::-webkit-scrollbar-track {
  background: #404040;
}
.menu-center .scroll-list {
  /* Handle */
}
.menu-center .scroll-list::-webkit-scrollbar-thumb {
  background: #FF914E;
}
.menu-center .scroll-list {
  /* Handle on hover */
}
.menu-center .scroll-list::-webkit-scrollbar-thumb:hover {
  background: #FF914E;
}
.menu-center button {
  background-color: var(--primary);
  color: #fff !important;
  padding: 4px 13px;
  font-size: 11px;
  margin-top: 10px;
  cursor: pointer;
  width: 100%;
}
.menu-center button:hover {
  background-color: var(--primary);
}

.img-arrow-dashboard {
  width: 8px !important;
}

.child-loader {
  position: relative;
}

.text-none {
  text-transform: none !important;
}

.reviewTable-accordion {
  box-shadow: unset;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 0px !important;
  margin-top: 0px !important;
}
.reviewTable-accordion::before {
  background-color: transparent !important;
  height: 0px !important;
}
.reviewTable-accordion .Mui-expanded.MuiAccordionSummary-gutters {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  min-height: 48px !important;
}
.reviewTable-accordion .MuiAccordionSummary-content {
  margin: 12px 0px !important;
}

.alerts-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
}
.alerts-container button {
  background-color: transparent !important;
}`, "",{"version":3,"sources":["webpack://./src/index.scss","webpack://./src/style.scss"],"names":[],"mappings":"AAAA,4BAAA;ACAA,YAAA;AAIA;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,kEAAA;EACA,yDAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;ADCF;;ACEA,yBAAA;AAIA,kBAAA;AAsFA,kBAAA;AAqCA,oBAAA;AASA,qBAAA;AAmBA,kBAAA;AAYA,oBAAA;AAaA,gBAAA;AAKA,yBAAA;AAMA,mBAAA;AAGA,2BAAA;AACA;EACE,eAhLM;EAiLN,kBAAA;EACA,gBAnEM;ADpHR;;AC0LA,eAAA;AACA;EACE,WAnDQ;EAoDR,aAhDK;ADvIP;;AC0LA,kBAAA;AACA;EACE,eAjMM;EAkMN,mBAAA;ADvLF;;AC0LA;EAEE,UAAA;EACA,qBAAA;EACA,eA/MK;EAgNL,gBAxFM;ADhGR;;AC2LA;EACE,qBAAA;EACA,yBAtDK;EAuDL,+BAAA;ADxLF;;AC2LA;EACE,kBApCO;EAqCP,gBAAA;ADxLF;;AC2LA;EACE,eAxLM;EAyLN,iBAtKM;EAuKN,mBA5MM;ADoBR;;AC4LA;EACE,eAvMM;EAwMN,iBAzLM;ADAR;;AC6LA;EACE,eAlNM;EAmNN,iBArLM;EAsLN,mBAnOM;ADyCR;;AC8LA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AD3LF;;AC+LA;EAEE,YAjOM;EAkON,iBAlOM;EAmON,YAAA;EACA,mBAAA;EACA,mBAAA;AD7LF;;ACgMA,kBAAA;AACA;EACE,kBAzFS;EA0FT,aAnHK;EAoHL,sBAjGO;EAkGP,YAAA;EACA,qBAlGU;EAmGV,8BAAA;EACA,2BAnGU;EAoGV,sCAAA;EACA,sBAAA;EACA,mDAAA;EACA,kBAAA;AD7LF;;ACgMA;EACE,qBAAA;EACA,yBApHK;EAqHL,+BAAA;AD7LF;;ACgMA;EACE,kBAlGO;EAmGP,gBAAA;AD7LF;;ACgMA;EACE,eAtPM;EAuPN,iBApOM;EAqON,mBA1QM;AD6ER;;ACiMA;EACE,eArQM;EAsQN,iBAvPM;ADyDR;;ACkMA;EACE,eAhRM;EAiRN,iBAnPM;EAoPN,mBAjSM;ADkGR;;ACmMA,qBAAA;AACA;EACE,kCAAA;EACA,gCAAA;EACA,4BAAA;EACA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,sCAAA;EACA,6BAAA;EACA,iCAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,0BAAA;EACA,qCAAA;ADhMF;;ACmMA;EACE,4BAAA;EACA,2BAAA;EACA,8BAAA;ADhMF;;ACmMA;EACE,2CAAA;EACA,2CAAA;EACA,8BAAA;EACA,2BAAA;ADhMF;;ACmMA;EACE,2CAAA;EACA,2CAAA;EACA,8BAAA;EACA,2BAAA;ADhMF;;ACkMA;EACE,sBAAA;AD/LF;;AC0ME;EACE,aAAA;ADvMJ;;ACmNE;EACE,aAAA;ADhNJ;;ACmNA;EACE,4BAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;ADhNF;ACiNE;EACE,2CAAA;AD/MJ;;ACmNA;EACE,6BAAA;EACA,gBAAA;EACA,kBAAA;ADhNF;;ACmNA,qBAAA;AAEE;EACE,iBA7WI;EA8WJ,oBA9WI;EA+WJ,iBAAA;ADjNJ;ACmNI;EACE,YAjZC;EAkZD,mBAAA;EACA,kBAxNG;ADOT;ACmNM;EACE,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,2BAAA;EACA,2BAAA;ADjNR;ACyNM;EACE,gBAvSA;EAwSA,eA/YA;EAgZA,iBAtYA;EAuYA,mBAAA;ADvNR;AC4NM;EACE,WAAA;EACA,kBA7PG;EA8PH,UAAA;EACA,UAAA;EACA,YAtRD;AD4DP;AC+NM;EAEE,oDAAA;AD9NR;ACgOQ;EACE,wCAAA;EACA,yCAAA;AD9NV;ACoOQ;EACE,gBArSH;ADmEP;;ACyOA,qBAAA;AACA;EACE,yCAAA;ADtOF;ACwOE;EACE,mBAraI;AD+LR;AC0OE;EACE,WAhUM;EAiUN,iBA1TG;EA2TH,cA7TI;EA8TJ,aAAA;EACA,wBAAA;EACA,8CAAA;EACA,mBApcI;EAqcJ,2BAAA;EACA,mBAjcI;EAkcJ,gCAAA;EACA,gCAAA;ADxOJ;AC0OI;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;ADxON;AC2OI;EACE,sBAAA;EACA,+DAAA;ADzON;;AC8OE;EACE,6BAAA;EACA,gBAAA;EACA,kBAAA;AD3OJ;;AC8OE,qBAAA;AAEE;EACE,iBAzdE;EA0dF,oBA1dE;EA2dF,iBAAA;AD5ON;AC8OM;EACE,YA7fD;EA8fC,mBAAA;EACA,kBApUC;ADwFT;AC8OQ;EACE,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,2BAAA;EACA,2BAAA;AD5OV;ACoPQ;EACE,gBAnZF;EAoZE,eA3fF;EA4fE,iBAlfF;EAmfE,mBAAA;ADlPV;ACuPQ;EACE,WAAA;EACA,kBAzWC;EA0WD,UAAA;EACA,UAAA;EACA,YAlYH;AD6IP;AC0PQ;EAEE,oDAAA;ADzPV;AC2PU;EACE,wCAAA;EACA,yCAAA;ADzPZ;AC+PU;EACE,gBAjZL;ADoJP;;ACoQE,qBAAA;AACA;EACE,gBAAA;EACA,yCAAA;EACA,mBAAA;ADjQJ;;ACoQE;EACE,yCAAA;ADjQJ;ACmQI;EACE,mBAvhBE;ADsRR;ACqQI;EACE,WAlbI;EAmbJ,iBA5aC;EA6aD,cA/aE;EAgbF,aAAA;EACA,wBAAA;EACA,8CAAA;EACA,mBAtjBE;EAujBF,2BAAA;EACA,mBAnjBE;EAojBF,gCAAA;EACA,gCAAA;ADnQN;ACqQM;EACE,2BAAA;EACA,6BAAA;ADnQR;ACsQM;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;ADpQR;ACuQM;EACE,sBAAA;EACA,+DAAA;ADrQR;;AAxXA;EACI,WC2BG;ED1BH,WC0BG;EDzBH,YCyBG;EDxBH,YCwBG;EDvBH,qBCoLG;EDnLH,sBAAA;EACA,iCAAA;EACA,oCAAA;AA2XJ;AAnWA;EACI;IACI,uBAAA;EAsXN;EAnXE;IACI,yBAAA;EAqXN;AACF;AAlXA,iBAAA;AACA;EACI,YCmIM;ADiPV;;AAjXA;EACI,SAAA;EACA,oCAAA;EACA,mCAAA;EACA,kCAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBCkGI;EDjGJ,gBAAA;AAoXJ;;AAjXA,qBAAA;AACA;EACI,8BAAA;EACA,4BAAA;EACA,SAAA;EAEA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,6BAAA;EACA,UAAA;EACA,kBAAA;AAoXJ;;AAjXA,oBAAA;AACA;;;;;;;;;;;;EAYI,qBAAA;EACA,gBAAA;EACA,gBAAA;AAoXJ;;AAjXA;;EAEI,kBAAA;AAoXJ;;AAjXA;EACI,kBCqHK;EDpHL,gBCqDI;EDpDJ,eCvDI;EDwDJ,iBC9CI;ED+CJ,mBCzDI;AD6aR;;AAjXA,oBAAA;AACA;EACI,6BAAA;AAoXJ;AAlXI;EACI,WCjEA;EDkEA,YClEA;ADsbR;AAjXI;EACI,yDAAA;EACA,4BAAA;AAmXR;AAjXQ;EACI,aAAA;AAmXZ;AA/WI;EACI,yDAAA;EACA,4BAAA;EACA,6BAAA;AAiXR;;AA5WI;EACI,WCtFA;EDuFA,YCvFA;ADscR;;AA3WA;EACI,gCAAA;AA8WJ;;AA3WA,wBAAA;AACA;EACI,yBAAA;AA8WJ;AA5WI;EACI,UCtHD;ADoeP;;AA1WA,iBAAA;AACA;EACI,uBAAA;AA6WJ;;AA1WA;EACI,wBAAA;AA6WJ;;AA1WA,qBAAA;AACA;EACI,4BAAA;AA6WJ;;AA1WA;EACI,4BAAA;AA6WJ;;AA1WA;EACI,4BAAA;AA6WJ;;AA1WA;EACI,4BAAA;AA6WJ;;AA1WA;EACI,4BAAA;AA6WJ;;AA1WA;EACI,4BAAA;AA6WJ;;AA1WA,wBAAA;AACA;EACI,+BAAA;AA6WJ;;AA1WA;EACI,+BAAA;AA6WJ;;AA1WA;EACI,+BAAA;AA6WJ;;AA1WA;EACI,+BAAA;AA6WJ;;AA1WA,sBAAA;AACA;EACI,iBC1KG;ADuhBP;;AA1WA;EACI,kBCzKI;ADshBR;;AA1WA;EACI,6BAAA;AA6WJ;;AA1WA;EACI,6BAAA;AA6WJ;;AA1WA;EACI,6BAAA;AA6WJ;;AA1WA;EACI,6BAAA;AA6WJ;;AA1WA;EACI,6BAAA;AA6WJ;;AA1WA;EACI,6BAAA;AA6WJ;;AA1WA,uBAAA;AACA;EACI,kBCtMI;ADmjBR;;AA1WA;EACI,8BAAA;AA6WJ;;AA1WA;EACI,8BAAA;AA6WJ;;AA1WA;EACI,8BAAA;AA6WJ;;AA1WA;EACI,8BAAA;AA6WJ;;AA1WA;EACI,8BAAA;AA6WJ;;AA1WA;EACI,8BAAA;AA6WJ;;AA1WA;EACI,8BAAA;AA6WJ;;AA1WA,2BAAA;AACA;EACI,6BAAA;EACA,8BAAA;AA6WJ;;AA1WA;EACI,6BAAA;EACA,8BAAA;AA6WJ;;AA1WA,2BAAA;AACA;EACI,2BAAA;EACA,8BAAA;AA6WJ;;AA1WA;EACI,2BAAA;EACA,8BAAA;AA6WJ;;AA1WA;EACI,6BAAA;EACA,8BAAA;AA6WJ;;AA1WA;EACI,2BAAA;EACA,8BAAA;AA6WJ;;AA1WA,gBAAA;AACA;EACI,uBAAA;AA6WJ;;AA1WA;EACI,uBAAA;AA6WJ;;AA1WA;EACI,2BAAA;AA6WJ;;AA1WA;EACI,2BAAA;AA6WJ;;AA1WA;EACI,4BAAA;AA6WJ;;AA1WA;EACI,iBCrRI;ADkoBR;;AAxWA;EACI,iBCtRI;ADioBR;;AAxWA;EACI,4BAAA;AA2WJ;;AAxWA;EACI,kBCrOK;ADglBT;;AAxWA,qBAAA;AACA;EACI,4BAAA;AA2WJ;;AAxWA;EACI,4BAAA;AA2WJ;;AAxWA;EACI,6BAAA;AA2WJ;;AAxWA;EACI,6BAAA;AA2WJ;;AAxWA,mBAAA;AACA;EACI,0BAAA;AA2WJ;;AAxWA;EACI,0BAAA;AA2WJ;;AAxWA;EACI,0BAAA;AA2WJ;;AAxWA;EACI,0BAAA;AA2WJ;;AAxWA;EACI,2BAAA;AA2WJ;;AAxWA;EACI,2BAAA;AA2WJ;;AAxWA;EACI,2BAAA;AA2WJ;;AAxWA;EACI,2BAAA;AA2WJ;;AAxWA;EACI,2BAAA;AA2WJ;;AAxWA;EACI,2BAAA;AA2WJ;;AAxWA;EACI,2BAAA;AA2WJ;;AAxWA,sBAAA;AACA;EACI,6BAAA;AA2WJ;;AAxWA;EACI,6BAAA;AA2WJ;;AAxWA;EACI,8BAAA;AA2WJ;;AAxWA;EACI,8BAAA;AA2WJ;;AAxWA;EACI,8BAAA;AA2WJ;;AAxWA;EACI,8BAAA;AA2WJ;;AAxWA;EACI,8BAAA;AA2WJ;;AAxWA;EACI,8BAAA;AA2WJ;;AAxWA;EACI,8BAAA;AA2WJ;;AAxWA,yBAAA;AACA;EACI,gBCjZI;EDkZJ,mBClZI;AD6vBR;;AAxWA,eAAA;AACA;EACI,2BAAA;AA2WJ;;AAxWA,eAAA;AACA;EACI,6BAAA;AA2WJ;;AAxWA;EACI,WAAA;AA2WJ;;AAxWA;EACI,YCrWK;ADgtBT;;AAxWA;EACI,uBAAA;AA2WJ;;AAxWA;EACI,uBAAA;AA2WJ;;AAxWA;EACI,wBAAA;AA2WJ;;AAxWA;EACI,wBAAA;AA2WJ;;AAxWA;EACI,WC/SM;AD0pBV;;AAxWA;EACI,UCrTK;ADgqBT;;AAxWA;EACI,qBAAA;AA2WJ;;AAxWA;EACI,qBAAA;AA2WJ;;AAxWA;EACI,UCpUK;AD+qBT;;AAxWA;EACI,qBAAA;AA2WJ;;AAxWA;EACI,UC/UK;AD0rBT;;AAxWA,qBAAA;AACA;EACI,6BAAA;AA2WJ;;AAxWA;EACI,2BAAA;AA2WJ;;AAxWA;EACI,4BAAA;AA2WJ;;AAxWA,iBAAA;AACA;EACI,yBAAA;AA2WJ;;AAxWA;EACI,wBAAA;AA2WJ;;AAxWA;EACI,wBAAA;AA2WJ;;AAxWA;EACI,wBAAA;AA2WJ;;AAxWA,uBAAA;AACA;EACI,kCAAA;AA2WJ;;AAxWA;EACI,gCAAA;AA2WJ;;AAxWA;EACI,iCAAA;AA2WJ;;AAxWA;EACI,yCAAA;AA2WJ;;AAxWA;EACI,+BAAA;AA2WJ;;AAxWA,iBAAA;AACA;EACI,kBAAA;AA2WJ;;AAxWA,qBAAA;AACA;EACI,gBCpXE;AD+tBN;;AAxWA;EACI,mBCtXK;ADiuBT;;AAxWA,uBAAA;AACA;EACI,eAAA;AA2WJ;;AAxWA;EACI,eAAA;AA2WJ;;AAxWA;;;EAGI,kCAAA;EACA,8BAAA;AA2WJ;;AAxWA,oBAAA;AACA;EACI,iCAAA;AA2WJ;;AAxWA,gBAAA;AAEI;EACI,wBAAA;EACA,wBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AA0WR;AAxWQ;EACI,kBCjaE;AD2wBd;AAxWY;EACI,qBAAA;AA0WhB;AAvWY;EACI,qBAAA;AAyWhB;AAtWY;EACI,qBAAA;AAwWhB;AArWY;;EAEI,2BAAA;AAuWhB;AAlWY;EACI,kBCplBT;EDqlBS,gBCzdR;ED0dQ,mBAAA;EACA,eAAA;EACA,iBCpkBR;EDqkBQ,mBCrbP;EDsbO,aCpcT;ADwyBP;AAlWgB;EACI,YCjhBX;EDkhBW,qBCpcN;EDqcM,gBCpeZ;ADw0BR;AA9VY;EACI,kBCtmBT;EDumBS,gBC3eR;ED4eQ,mBAAA;EACA,eAAA;EACA,iBCtlBR;EDulBQ,mBCvcP;EDwcO,uBAAA;AAgWhB;AA5VQ;EACI,mBAAA;AA8VZ;;AAzVA,yBAAA;AACA;EACI,2BAAA;AA4VJ;;AAzVA,kBAAA;AACA;EACI,0BAAA;EACA,yBAAA;EACA,6BAAA;AA4VJ;;AAzVA;EACI,0BAAA;EACA,yBAAA;EACA,qBAAA;AA4VJ;;AAzVA,wBAAA;AACA;;EAEI,2BAAA;EACA,qBAAA;AA4VJ;;AAzVA;;;;;;EAMI,0BAAA;EACA,gBAAA;EACA,2BAAA;EACA,2BAAA;EACA,uDAAA;EACA,yBAAA;EACA,6BAAA;EACA,+BAAA;EACA,6BAAA;EACA,WAAA;EACA,iBAAA;EACA,8BAAA;AA4VJ;AA1VI;;;;;;EACI,aAAA;EACA,gBAAA;EACA,aAAA;EACA,QAAA;EACA,gBAAA;AAiWR;AA/VQ;;;;;;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,4BAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,yDAAA;EACA,kBAAA;AAsWZ;AAlWI;;;;;;EACI,eAAA;EACA,yBAAA;EACA,uBAAA;AAyWR;AAvWQ;;;;;;EACI,qCAAA;AA8WZ;AA3WQ;;;;;;;;;;;;;;;;EAGI,+CAAA;EACA,yBAAA;AA0XZ;;AArXA;;EAEI,0BAAA;EACA,iCAAA;EACA,2BAAA;EACA,2BAAA;EACA,yCAAA;EACA,0CAAA;EACA,qBAAA;EACA,6BAAA;EACA,YAAA;EACA,0BAAA;EACA,qBAAA;EACA,6BAAA;EACA,4DAAA;EACA,8BAAA;AAwXJ;AAtXI;;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,2BAAA;EACA,2BAAA;EACA,kCAAA;EACA,cAAA;EACA,uBAAA;EACA,0BAAA;EACA,sCAAA;AAyXR;AAvXQ;;EACI,eAAA;EACA,iBAAA;AA0XZ;AAvXQ;;EACI,2CAAA;EACA,mBAAA;AA0XZ;;AArXA;EACI,4BAAA;EACA,2BAAA;AAwXJ;AArXQ;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;AAuXZ;AArXY;EACI,6BAAA;AAuXhB;;AAjXA,cAAA;AACA;;EAEI,kBAAA;AAoXJ;;AAjXA;EACI,wBAAA;AAoXJ;;AAjXA;EACI,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAoXJ;;AAjXA;EACI,yCAAA;AAoXJ;;AAjXA;EACI;IACI,2BAAA;EAoXN;EAjXE;IACI,4BAAA;EAmXN;AACF;AAhXA,4EAAA;AACA;EACI,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAkXJ;;AA/WA;EACI,aAAA;AAkXJ;;AA/WA;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;AAkXJ;;AA/WA;EACI,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AAkXJ;;AA/WA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AAkXJ;;AA/WA;;EAEI,WAAA;EACA,YAAA;EACA,oEAAA;EACA,wBAAA;EACA,4BAAA;EACA,wBAAA;EACA,0BAAA;EACA,YAAA;EACA,gBAAA;EACA,uCAAA;AAkXJ;;AA/WA;;EAEI,oEAAA;EACA,wBAAA;EACA,4BAAA;EACA,0BAAA;AAkXJ;;AA/WA;EACI,gCAAA;AAkXJ;;AA/WA;EACI,2BAAA;AAkXJ;;AA/WA;EACI,oBAAA;EACA,0BAAA;EACA,mCAAA;EACA,iCAAA;AAkXJ;;AA/WA;EACI,mBAAA;EACA,wBAAA;AAkXJ;AAhXI;EACI,iBAAA;AAkXR;AA/WI;EACI,qBAAA;AAiXR;;AA5WI;EACI,kCAAA;EACA,yBAAA;EACA,oCAAA;EACA,6BAAA;AA+WR;AA7WQ;EAGI,sBAAA;EACA,oCAAA;EACA,gCAAA;AA6WZ;;AAxWA;EACI,YAAA;AA2WJ;;AAtWA;EACI,qBAAA;AAyWJ;;AArWA;EACI,yBAAA;EACA,eAAA;AAwWJ;;AArWA;EACI,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,qBAAA;AAwWJ;;AArWA;EACI,UAAA;AAwWJ;;AApWA;EACI,cAAA;EACA,WAAA;EACA,mCAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,4BAAA;EACA,yBAAA;EACA,sBAAA;EACA,wEAAA;AAuWJ;;AApWA;EACI,0BAAA;EACA,mBAAA;EACA,UAAA;AAuWJ;;AAnWA;EACI,8BAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;AAsWJ;AApWI;EACI,iBAAA;AAsWR;AAnWI;EACI,kBAAA;EACA,QAAA;AAqWR;;AAjWA;EACI,kBAAA;AAoWJ;;AAjWA;EACI,cAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;AAoWJ;;AAjWA;;EAEI,2BAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,0BAAA;EACA,4BAAA;EACA,sBAAA;EACA,gBAAA;AAoWJ;AA/VY;;EACI,WAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAkWhB;AAhWgB;;EACI,4BAAA;EACA,6BAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;AAmWpB;AAjWoB;;EACI,+CAAA;EACA,sBAAA;AAoWxB;AAhWgB;;EACI,+CAAA;EACA,yBAAA;EACA,gBAAA;AAmWpB;AAhWgB;;EACI,8BAAA;AAmWpB;AA7VI;;EACI,aAAA;AAgWR;;AA1VI;;;EAGI,wBAAA;AA6VR;;AAzVA;EACI,wBAAA;AA4VJ;;AAvVI;EACI,UAAA;AA0VR;AAvVI;EACI,4CAAA;AAyVR;AAtVI;EACI,mBAAA;AAwVR;AArVI;EACI,mBAAA;EACA,eAAA;AAuVR;;AAnVA,8BAAA;AACA;EACI,eAAA;EACA,WAAA;AAsVJ;;AAnVA;EACI,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;AAsVJ;;AAnVA;EACI,kBAAA;EACA,iBAAA;AAsVJ;;AAnVA;EACI,cAAA;AAsVJ;;AAnVA;;EAEI,0BAAA;AAsVJ;;AAnVA;EACI,2BAAA;AAsVJ;;AAnVA;EACI,+CAAA;EACA,yBAAA;AAsVJ;;AAnVA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;AAsVJ;AApVI;EACI,2BAAA;EACA,6BAAA;EACA,8BAAA;EACA,mBAAA;AAsVR;AAnVI;EACI,0BAAA;EACA,UAAA;EACA,uBAAA;EACA,6BAAA;EACA,2BAAA;EACA,yBAAA;AAqVR;;AAjVA;EACI,yBAAA;EACA,qBC3+BG;ED4+BH,6BC1+BU;ED2+BV,0BAAA;EACA,qBAAA;EACA,2BAAA;EACA,+BAAA;AAoVJ;;AAhVI;EACI,UAAA;AAmVR;;AA/UA;;EAEI,wBAAA;AAkVJ;AAhVI;;EACI,sBAAA;EACA,eCzgCE;ED0gCF,uBAAA;EACA,sBAAA;AAmVR;;AA/UA;EACI,yBAAA;AAkVJ;;AA9UA;EACI,kCAAA;EACA,kEAAA;EACA,yBAAA;EACA,6BAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;AAiVJ;AA/UI;EACI,0BAAA;EACA,kCAAA;EACA,WAAA;EACA,aAAA;AAiVR;AA/UQ;EACI,UAAA;AAiVZ;AA9UQ;EACI,iBAAA;AAgVZ;AA7UQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AA+UZ;AA5UQ;EACI,cAAA;EACA,WAAA;AA8UZ;AA3UQ;EACI,cAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AA6UZ;AA3UY;EACI,YAAA;EACA,oBAAA;AA6UhB;AAxUI;EACI,WAAA;EACA,uBAAA;EACA,6BAAA;EACA,0BAAA;EACA,0BAAA;EACA,qCAAA;EACA,2BAAA;EACA,yBAAA;AA0UR;AAtUI;EACI,oCAAA;EACA,oCAAA;AAwUR;AArUI;EACI,oCAAA;EACA,oCAAA;AAuUR;;AAjUQ;EACI,oCAAA;EACA,sBAAA;AAoUZ;AAlUY;EACI,gCAAA;AAoUhB;;AA9TA;EACI,4BAAA;EACA,kCAAA;EACA,kEAAA;EACA,yBAAA;EACA,6BAAA;EACA,sBAAA;AAiUJ;AA/TI;EACI,0BAAA;EACA,kCAAA;EACA,UAAA;EACA,kBAAA;AAiUR;AA/TQ;EACI,iBAAA;EACA,WAAA;AAiUZ;AA9TQ;EACI,qCAAA;EACA,kCAAA;EACA,6BAAA;AAgUZ;AA9TY;EACI,qBAAA;AAgUhB;;AAzTA;;EAEI,kBAAA;AA4TJ;AA1TI;;EACI,cAAA;EACA,kBAAA;EACA,UAAA;AA6TR;AA1TI;;EACI,cAAA;AA6TR;;AAxTA;EACI,qBAAA;AA2TJ;;AAxTA;EACI,WAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;AA2TJ;;AAxTA;EACI,aAAA;EACA,mBAAA;AA2TJ;AAzTI;EACI,iBAAA;EACA,kBAAA;EACA,gCAAA;EACA,WAAA;EACA,iBAAA;AA2TR;;AAvTA;EACI,eAAA;EACA,qBAAA;EACA,gBAAA;AA0TJ;;AAvTA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AA0TJ;;AAvTA;EACI,kBAAA;EACA,oBAAA;AA0TJ;;AAvTA;;;;;;;;;EASI,0BAAA;AA0TJ;;AAvTA;EACI,oCAAA;AA0TJ;;AAvTA;EACI,oBAAA;AA0TJ;;AAvTA;EAEI,4BAAA;AAyTJ;;AAtTA;EACI,yBAAA;AAyTJ;;AAtTA;EACI,kBAAA;AAyTJ;AAvTI;EACI,kBAAA;EACA,UAAA;EACA,yBAAA;AAyTR;AAtTI;EACI,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,gCAAA;AAwTR;AAtTQ;EACI,eAAA;AAwTZ;;AAnTA;EACI,kBAAA;EACA,uBAAA;EAEA,UAAA;AAqTJ;AApTI;EACI,UAAA;EACA,WAAA;EACA,eAAA;AAsTR;AA9TA;EAWI,UAAA;AAsTJ;AArTI;EACI,mBAAA;EACA,eAAA;AAuTR;AArUA;EAiBI,WAAA;AAuTJ;AAtTI;EACI,mBAAA;EACA,eAAA;AAwTR;AA5UA;EAuBI,oBAAA;AAwTJ;AAvTI;EACI,mBAAA;AAyTR;;AApTI;EACI,aAAA;EACA,mBAAA;AAuTR;AArTQ;EACI,iBAAA;EACA,WAAA;EACA,YAAA;AAuTZ;;AAlTA;EACI,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AAqTJ;;AAlTA;EACI,4CAAA;EACA,yBAAA;AAqTJ;;AAlTA;;;;EAII,6BAAA;EACA,6BAAA;EACA,kCAAA;AAqTJ;;AAlTA;;EAEI,UAAA;EACA,WAAA;AAqTJ;;AAlTA,UAAA;AACA;;EAEI,4CAAA;EACA,kBAAA;AAqTJ;;AAlTA,WAAA;AACA;;EAEI,eAAA;EACA,mBAAA;AAqTJ;;AAlTA,oBAAA;AACA;;EAEI,mBAAA;AAqTJ;;AAlTA;EACI,+BAAA;AAqTJ;;AAjTI;EACI,qBAAA;AAoTR;AAlTQ;EACI,gCAAA;AAoTZ;AAjTQ;EACI,iBAAA;EACA,iBAAA;EACA,cAAA;AAmTZ;AAjTY;EACI,uBAAA;AAmThB;AAhTY;EACI,qBAAA;AAkThB;AA/SY;EACI,qBAAA;AAiThB;AA9SY;EACI,qBAAA;AAgThB;AA5SY;EACI,UAAA;AA8ShB;AA3SY;EACI,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AA6ShB;AA1SY;EACI,kBAAA;EACA,mBAAA;AA4ShB;AAzSY;EACI,gBAAA;AA2ShB;AAvSQ;EACI,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAySZ;;AApSA;EACI,uBAAA;AAuSJ;AArSI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,4BAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;AAuSR;AApSI;EACI,6BAAA;EACA,0BAAA;EACA,2BAAA;AAsSR;AAnSI;;EAEI,6BAAA;EACA,0BAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;AAqSR;AAlSI;EACI,aAAA;EACA,8BAAA;EACA,8BAAA;EACA,kBAAA;AAoSR;AAlSQ;EACI,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,wBAAA;AAoSZ;AAnSY;EACI,wCAAA;AAqShB;AAhSI;EACI,WAAA;AAkSR;AAhSQ;EACI,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;AAkSZ;AAhSY;EACI,UAAA;AAkShB;AA/RY;EACI,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AAiShB;AA9RY;EACI,kBAAA;EACA,mBAAA;AAgShB;AA7RY;EACI,gBAAA;AA+RhB;AA5RY;EACI,uBAAA;AA8RhB;AA3RY;EACI,2BAAA;AA6RhB;AAzRgB;EACI,gBAAA;AA2RpB;AAzRoB;EACI,eAAA;EACA,eAAA;AA2RxB;AApRI;EACI,oCAAA;EACA,oCAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AAsRR;;AAjRI;EACI,2BAAA;EACA,uBAAA;EACA,wBAAA;EACA,kBAAA;EACA,mBAAA;AAoRR;AAjRI;EACI,kBAAA;EACA,0BAAA;EACA,gBAAA;EACA,kBAAA;AAmRR;AAhRI;EACI,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAkRR;AA/QI;EACI,eAAA;EACA,6BAAA;EACA,eAAA;AAiRR;AA/QQ;EAGI,6BAAA;EACA,eAAA;AA+QZ;;AA1QA;EACI,YAAA;EACA,kBAAA;EACA,QAAA;AA6QJ;;AA1QA;EACI,6BAAA;EACA,iBAAA;EACA,0BAAA;EACA,2CAAA;EACA,2CAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,6BAAA;EACA,sCAAA;EACA,6BAAA;EACA,iCAAA;EACA,gCAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,0BAAA;EACA,qCAAA;AA6QJ;;AA1QA;EACI,YAAA;EACA,8BAAA;AA6QJ;;AA1QA;EACI,8BAAA;AA6QJ;;AA1QA;EACI,wBAAA;AA6QJ;;AA1QA;EACI,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,2BAAA;EACA,2BAAA;EACA,6BAAA;AA6QJ;;AA1QA;EACI,mBAAA;EACA,mBAAA;AA6QJ;AA3QI;EACI,uBAAA;EACA,uBAAA;EACA,6BAAA;EACA,uBAAA;EACA,kCAAA;EACA,kCAAA;EACA,mBAAA;AA6QR;;AAzQA;EACI,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,uBAAA;EACA,eAAA;EACA,6BAAA;AA4QJ;;AAzQA;EACI,oCAAA;AA4QJ;;AAzQA;EACI,oCAAA;EACA,YAAA;AA4QJ;;AAzQA;EACI,oCAAA;AA4QJ;;AAxQA;EACI,oCAAA;EACA,mCAAA;EACA,gCAAA;EACA,0CAAA;AA2QJ;;AAxQA;EACI,WAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,8BAAA;AA2QJ;;AAxQA;EACI,kEAAA;EACA,yBAAA;EACA,6BAAA;EACA,sBAAA;EACA,qBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EAEA,+CAAA;AA2QJ;;AAxQA;EACI,eAAA;EACA,gBAAA;AA2QJ;AAzQI;EACI,aAAA;EACA,mBAAA;EACA,6CAAA;AA2QR;AAzQQ;EACI,iBAAA;AA2QZ;AAvQI;EACI,wCAAA;EACA,6CAAA;AAyQR;;AArQA;EACI,UAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EAEA,+CAAA;AAwQJ;;AArQA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAwQJ;AAtQI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AAwQR;AAtQQ;EACI,4BAAA;AAwQZ;AApQI;EACI,4BAAA;AAsQR;AAnQI;EACI,iBAAA;EACA,cAAA;EACA,eAAA;AAqQR;AAnQQ;EACI,UAAA;AAqQZ;AA3QI;EASI,UAAA;AAqQR;AApQQ;EACI,mBAAA;AAsQZ;AAjRI;EAcI,WAAA;AAsQR;AArQQ;EACI,mBAAA;AAuQZ;AAvRI;EAmBI,oBAAA;AAuQR;AAtQQ;EACI,mBAAA;AAwQZ;AApQI;EACI,gCAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AAsQR;AApQQ;EACI,gCAAA;AAsQZ;;AAjQA;EACI,qBAAA;AAoQJ;;AAjQA;EACI,kBAAA;AAoQJ;;AAjQA;EACI,+BAAA;AAoQJ;;AAjQA;EACI,iBAAA;EACA,YAAA;EACA,4CAAA;EACA,6BAAA;EACA,0BAAA;AAoQJ;AAlQI;EACI,wCAAA;EACA,sBAAA;AAoQR;AAjQI;EACI,4CAAA;EACA,2BAAA;AAmQR;AAhQI;EACI,2BAAA;AAkQR;;AA7PA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAgQJ;AA/PI;EACI,wCAAA;AAiQR","sourcesContent":["/*--style import constant--*/\n@import \"./style.scss\";\n\n* {\n    margin: $px-0;\n    border: $px-0;\n    padding: $px-0;\n    outline: $px-0;\n    text-decoration: $none;\n    box-sizing: border-box;\n    letter-spacing: normal !important;\n    font-family: $montserrat !important;\n}\n\n//Spin Loader for Icon\n@-moz-keyframes spin {\n    from {\n        -moz-transform: rotate(0deg);\n    }\n\n    to {\n        -moz-transform: rotate(360deg);\n    }\n}\n\n@-webkit-keyframes spin {\n    from {\n        -webkit-transform: rotate(0deg);\n    }\n\n    to {\n        -webkit-transform: rotate(360deg);\n    }\n}\n\n@keyframes spin {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/*--Body Style--*/\nhtml {\n    height: $per-100;\n}\n\nbody {\n    margin: 0;\n    font-family: $montserrat !important;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    min-height: $per-100 !important;\n    font-display: swap;\n    font-weight: $f-400;\n    line-height: 1.5;\n}\n\n/*-- Link txt SEO --*/\n.hidden-link-txt {\n    clip: rect(1px, 1px, 1px, 1px);\n    word-wrap: normal !important;\n    border: 0;\n    -webkit-clip-path: inset(50%);\n    clip-path: inset(50%);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute !important;\n    width: 1px;\n    word-break: normal;\n}\n\n/*-- Font Styles --*/\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    margin-bottom: 0.5rem;\n    font-weight: 500;\n    line-height: 1.2;\n}\n\n.h3,\nh3 {\n    font-size: 1.75rem;\n}\n\np {\n    font-style: $normal;\n    font-weight: $f-400;\n    font-size: $f-16;\n    line-height: $px-26;\n    margin-bottom: $px-16;\n}\n\n/*-- Forms Styles--*/\n.MuiCheckbox-root {\n    padding-right: $px-0 !important;\n\n    svg {\n        width: $px-16;\n        height: $px-16;\n    }\n\n    svg[data-testid=\"CheckBoxOutlineBlankIcon\"] {\n        background-image: url(\"./assets/images/unchecked.webp\");\n        background-repeat: no-repeat;\n\n        path {\n            display: none;\n        }\n    }\n\n    svg[data-testid=\"CheckBoxIcon\"] {\n        background-image: url(\"./assets/images/checked.webp\");\n        background-repeat: no-repeat;\n        color: transparent !important;\n    }\n}\n\n.MuiRadio-root {\n    svg {\n        width: $px-17;\n        height: $px-17;\n    }\n}\n\n.MuiRadio-root.Mui-checked {\n    color: var(--primary) !important;\n}\n\n/*--Scroll bar style --*/\n.hidden-scroll {\n    overflow: auto !important;\n\n    &::-webkit-scrollbar {\n        width: $px-0;\n    }\n}\n\n/* -- padding --*/\n.p-0 {\n    padding: $px-0 !important;\n}\n\n.p-10 {\n    padding: $px-10 !important;\n}\n\n/* -- padding top --*/\n.pt-18 {\n    padding-top: $px-18 !important;\n}\n\n.pt-22 {\n    padding-top: $px-22 !important;\n}\n\n.pt-40 {\n    padding-top: $px-40 !important;\n}\n\n.pt-50 {\n    padding-top: $px-50 !important;\n}\n\n.pt-70 {\n    padding-top: $px-70 !important;\n}\n\n.pt-85 {\n    padding-top: $px-85 !important;\n}\n\n/* -- padding bottom --*/\n.pb-40 {\n    padding-bottom: $px-40 !important;\n}\n\n.pb-50 {\n    padding-bottom: $px-50 !important;\n}\n\n.pb-70 {\n    padding-bottom: $px-70 !important;\n}\n\n.pb-85 {\n    padding-bottom: $px-85 !important;\n}\n\n/* -- padding left --*/\n.pl-5 {\n    padding-left: $px-5;\n}\n\n.pl-10 {\n    padding-left: $px-10;\n}\n\n.pl-15 {\n    padding-left: $px-15 !important;\n}\n\n.pl-20 {\n    padding-left: $px-20 !important;\n}\n\n.pl-30 {\n    padding-left: $px-30 !important;\n}\n\n.pl-40 {\n    padding-left: $px-40 !important;\n}\n\n.pl-45 {\n    padding-left: $px-45 !important;\n}\n\n.pl-65 {\n    padding-left: $px-65 !important;\n}\n\n/* -- padding right --*/\n.pr-10 {\n    padding-left: $px-10;\n}\n\n.pr-15 {\n    padding-right: $px-15 !important;\n}\n\n.pr-20 {\n    padding-right: $px-20 !important;\n}\n\n.pr-30 {\n    padding-right: $px-30 !important;\n}\n\n.pr-40 {\n    padding-right: $px-40 !important;\n}\n\n.pr-45 {\n    padding-right: $px-45 !important;\n}\n\n.pr-60 {\n    padding-right: $px-60 !important;\n}\n\n.pr-75 {\n    padding-right: $px-75 !important;\n}\n\n/* -- padding left right--*/\n.plr-15 {\n    padding-left: $px-15 !important;\n    padding-right: $px-15 !important;\n}\n\n.plr-16 {\n    padding-left: $px-16 !important;\n    padding-right: $px-16 !important;\n}\n\n/* -- padding top bottom--*/\n.ptb-3 {\n    padding-top: $px-3 !important;\n    padding-bottom: $px-3 !important;\n}\n\n.ptb-8 {\n    padding-top: $px-8 !important;\n    padding-bottom: $px-8 !important;\n}\n\n.plr-16 {\n    padding-left: $px-16 !important;\n    padding-right: $px-16 !important;\n}\n\n.ptb-8 {\n    padding-top: $px-8 !important;\n    padding-bottom: $px-8 !important;\n}\n\n/* -- margin --*/\n.m-auto {\n    margin: $auto !important;\n}\n\n.m-10 {\n    margin: $px-10 !important;\n}\n\n.ml-0 {\n    margin-left: $px-0 !important;\n}\n\n.ml-5 {\n    margin-left: $px-5 !important;\n}\n\n.ml-10 {\n    margin-left: $px-10 !important;\n}\n\n.ml-15 {\n    margin-left: $px-15;\n}\n\n\n\n.ml-20 {\n    margin-left: $px-20;\n}\n\n.ml-47 {\n    margin-left: $px-47 !important;\n}\n\n.ml-200 {\n    margin-left: $px-200;\n}\n\n/* -- margin right--*/\n.mr-0 {\n    margin-right: $px-0 !important;\n}\n\n.mr-5 {\n    margin-right: $px-5 !important;\n}\n\n.mr-10 {\n    margin-right: $px-10 !important;\n}\n\n.mr-15 {\n    margin-right: $px-15 !important;\n}\n\n/* -- margin top--*/\n.mt-0 {\n    margin-top: $px-0 !important;\n}\n\n.mt-3 {\n    margin-top: $px-3 !important;\n}\n\n.mt-5 {\n    margin-top: $px-5 !important;\n}\n\n.mt-8 {\n    margin-top: $px-8 !important;\n}\n\n.mt-10 {\n    margin-top: $px-10 !important;\n}\n\n.mt-15 {\n    margin-top: $px-15 !important;\n}\n\n.mt-20 {\n    margin-top: $px-20 !important;\n}\n\n.mt-30 {\n    margin-top: $px-30 !important;\n}\n\n.mt-50 {\n    margin-top: $px-50 !important;\n}\n\n.mt-70 {\n    margin-top: $px-80 !important;\n}\n\n.mt-80 {\n    margin-top: $px-80 !important;\n}\n\n/* -- margin bottom--*/\n.mb-0 {\n    margin-bottom: $px-0 !important;\n}\n\n.mb-5 {\n    margin-bottom: $px-5 !important;\n}\n\n.mb-10 {\n    margin-bottom: $px-10 !important;\n}\n\n.mb-12 {\n    margin-bottom: $px-12 !important;\n}\n\n.mb-15 {\n    margin-bottom: $px-15 !important;\n}\n\n.mb-30 {\n    margin-bottom: $px-30 !important;\n}\n\n.mb-50 {\n    margin-bottom: $px-50 !important;\n}\n\n.mb-60 {\n    margin-bottom: $px-60 !important;\n}\n\n.mb-70 {\n    margin-bottom: $px-70 !important;\n}\n\n/* -- margin top bottom */\n.mtb-10 {\n    margin-top: $px-10;\n    margin-bottom: $px-10;\n}\n\n/* --height --*/\n.h-32 {\n    min-height: 32px !important;\n}\n\n/* -- width --*/\n.w-fit {\n    width: fit-content !important;\n}\n\n.w-18px {\n    width: 18px;\n}\n\n.w-115px {\n    width: $px-115;\n}\n\n.w-200px {\n    width: 200px !important;\n}\n\n.w-250px {\n    width: $px-250 !important;\n}\n\n.h-280px {\n    height: 280px !important;\n}\n\n.h-250px {\n    height: 205px !important;\n}\n\n.w-100 {\n    width: $per-100;\n}\n\n.w-90 {\n    width: $per-90;\n}\n\n.w-60 {\n    width: $per-60 !important;\n}\n\n.w-50 {\n    width: $per-50 !important;\n}\n\n.w-55 {\n    width: $per-55;\n}\n\n.w-40 {\n    width: $per-40 !important;\n}\n\n.w-45 {\n    width: $per-45;\n}\n\n/* -- text-center --*/\n.text-center {\n    text-align: $center !important;\n}\n\n.text-left {\n    text-align: $left !important;\n}\n\n.text-right {\n    text-align: $right !important;\n}\n\n/* -- display --*/\n.d-block {\n    display: $block !important;\n}\n\n.d-flex {\n    display: $flex !important;\n}\n\n.d-grid {\n    display: $grid !important;\n}\n\n.d-none {\n    display: $none !important;\n}\n\n/* -- justify content */\n.justyfy-center {\n    justify-content: $center !important;\n}\n\n.justyfy-left {\n    justify-content: $left !important;\n}\n\n.justyfy-right {\n    justify-content: $right !important;\n}\n\n.justyfy-space-between {\n    justify-content: $space-between !important;\n}\n\n.justyfy-end {\n    justify-content: $end !important;\n}\n\n/*-- Positions--*/\n.p-absolute {\n    position: absolute;\n}\n\n/* --- align item --*/\n.align-top {\n    align-items: $top;\n}\n\n.align-center {\n    align-items: $center;\n}\n\n/*-- Cursor pointer --*/\n.cursor-p {\n    cursor: pointer;\n}\n\n.cursor-d {\n    cursor: default;\n}\n\n.cursor-d,\n.cursor-d input[type=checkbox],\n.cursor-d svg {\n    pointer-events: visible !important;\n    cursor: not-allowed !important;\n}\n\n/*--Flex-dirction--*/\n.flexdirection-col {\n    flex-direction: column !important;\n}\n\n/*-- ToolTip --*/\ndiv[role=\"tooltip\"] {\n    .MuiTooltip-tooltip {\n        padding: $px-6 $px-7 $px-6 $px-9;\n        background: var(--black);\n        color: #fff;\n        opacity: 1;\n        z-index: 999;\n        min-width: 80%;\n        max-width: 100%;\n\n        .table-tooltip {\n            width: $max-content;\n\n            .column-2 {\n                columns: 2 !important;\n            }\n\n            .column-3 {\n                columns: 3 !important;\n            }\n\n            .column-4 {\n                columns: 4 !important;\n            }\n\n            .ul,\n            li {\n                list-style: none !important;\n\n\n            }\n\n            p {\n                margin-bottom: $px-1;\n                font-weight: $f-500;\n                color: var(--white);\n                font-size: 10px;\n                line-height: $px-20;\n                align-items: $center;\n                display: $flex;\n\n                span {\n                    width: $px-150;\n                    display: $inlineblock;\n                    font-weight: $f-400;\n                }\n            }\n        }\n\n        .paratooltip {\n            p {\n                margin-bottom: $px-1;\n                font-weight: $f-500;\n                color: var(--white);\n                font-size: 10px;\n                line-height: $px-20;\n                align-items: $center;\n                width: 300px !important;\n            }\n        }\n\n        .MuiTooltip-arrow {\n            color: var(--black);\n        }\n    }\n}\n\n/*-- Background Colors--*/\n.background-blue {\n    background: var(--liteblue);\n}\n\n/*-- error txt --*/\n.err {\n    font-size: $f-10 !important;\n    color: #f15d48 !important;\n    margin-bottom: $px-0 !important;\n}\n\n.Mui-error {\n    font-size: $f-11 !important;\n    color: #f15d47 !important;\n    opacity: 1 !important;\n}\n\n/* -- select drop down */\n.menus-container,\n.MuiAutocomplete-popper {\n    max-width: 300px !important;\n    opacity: 1 !important;\n}\n\n.MuiPopper-root[data-popper-placement=\"bottom-start\"]:not(.MuiTooltip-popper),\n.MuiPopper-root[data-popper-placement=\"top-start\"]:not(.MuiTooltip-popper),\n.MuiPopper-root[data-popper-placement=\"bottom-end\"]:not(.MuiTooltip-popper),\n.base-Popper-root[data-popper-placement=\"bottom-start\"]:not(.MuiTooltip-popper),\n.base-Popper-root[data-popper-placement=\"top-start\"]:not(.MuiTooltip-popper),\n.base-Popper-root[data-popper-placement=\"bottom-end\"]:not(.MuiTooltip-popper) {\n    font-size: 12px !important;\n    max-width: 172px;\n    overflow-y: auto !important;\n    font-weight: 300 !important;\n    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2509803922);\n    border: 1px solid #D9E2E5;\n    border-radius: 8px !important;\n    z-index: 99999999999 !important;\n    overflow-x: hidden !important;\n    width: 100%;\n    max-height: 15rem;\n    background-color: var(--white);\n\n    .route-search {\n        padding: 10px;\n        position: sticky;\n        z-index: 9999;\n        top: 0px;\n        background: #fff;\n\n        input[type=\"text\"] {\n            width: 100%;\n            height: 30px;\n            line-height: 30px;\n            opacity: 0.8;\n            border: 1px solid #F4F6F7;\n            border-radius: 8px !important;\n            background-color: #F4F6F7 !important;\n            background-repeat: no-repeat;\n            background-position: 0;\n            padding: 8px;\n            background-size: 26px;\n            background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAA9hAAAPYQGoP6dpAAAAIGNIUk0AAHolAACAgwAA+f8AAIDoAABSCAABFVgAADqXAAAXb9daH5AAAALoSURBVHja7NlNiB1FEMDx39MoQRQjbDQHo+6grJqD+EEcD0oIUXMyBEHB4EFEnEBykiDJTUUhB8Gv4OQQvxEDKgh6MKsiXjIH8SoaGT/2EOOaL13BQ+R5qYVHM8/srsm8zTIFj0d3dc30f6aqurqn1+/3LQU5zxKRDqQD6UA6kA6kA+lAsOz/XiAva7gC63E3bsDlof4N3+IAvsSvqX1VZKMHyct6BbZgOyYahmTI8Qi+w0t4FycWjWvlZX0NXsMrQyBSmcCesLl6UYDkZT2O/di8APPNYTs+0hgJd3oZaxvUn0UsTKGPq7AOG5Jxt4ebPYQ/zwRIbz77kbyse3gcryaqKezCp5hOdCuxEc9idaLbir1VkfXbdq1VeCLp+xkP4J0GCNH3Nh7EL4lux0CGaxVkPa4daJ+KyVRzsD2IJ8NmMKvdMwqQe5P2F/Gbq0xGHA3KxlGA3NgwsaPzsD/aAHJdXtbntw2S+vOPC7jnT5HRZmUFlrcNkj65hWSbPnrJHHptg/yetK9cwD1Tm5P4u22Q75P2Olw6D/tLcGfSV1dFdqptkANJ+z7cMQ/7u7CpIWG0nrUmcSSJmeeidD+drMHTuCBJFh+PAmQKLyZ9N+OtqKeWDannNuAN3JLovsGx1mutqLfG8ElD0XgSH8Uqfzgy0arYj2waEkt/BeCuqsj+aBUkYG7Ce7h+yJCZ+L94jpf8ENuqIjvcKkjA3BYbpbVnaEvxFR6tiuyHVneIVZF9HS7zfLhV/zSL4JEo/w/+R0bbn5f1ra2+kWSPMoH7ozrOBlxqBjU+xwc4FO64L2KnSWoUVZFNtg2Sdl2GsYFK4HiD2Tj2xqnLsApia1Vk74/yXOt4PPlDQyBm148tkTCaZAxv5mX98ChB5irTeAwvDNFfhGfOBZDZGNqBnfinQX/huQIiCsbd8XZmEvXus3YcdJZg+ng9L+tpPBUxsgdla1lrsUj3WaED6UA6kA6kA+lAlhLIvwMAM2C/OO/NjgIAAAAASUVORK5CYII=);\n            padding-left: 30px;\n        }\n    }\n\n    li {\n        font-size: 12px;\n        white-space: break-spaces;\n        z-index: 999 !important;\n\n        &:hover {\n            background-color: rgba(0, 0, 0, 0.04);\n        }\n\n        &:focus,\n        &:active,\n        &:focus-visible {\n            background-color: rgb(217, 226, 229) !important;\n            color: #384648 !important;\n        }\n    }\n}\n\n.MuiPopper-root[id=\"simple-popper\"],\n.base-Popper-root[id=\"simple-popper\"] {\n    font-size: 12px !important;\n    max-width: fit-content !important;\n    overflow-y: auto !important;\n    font-weight: 300 !important;\n    border-bottom-left-radius: 4px !important;\n    border-bottom-right-radius: 4px !important;\n    z-index: 2 !important;\n    overflow-x: hidden !important;\n    width: 200px;\n    margin-top: 7px !important;\n    padding: 3px 15px 5px;\n    margin-left: -26px !important;\n    box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .5) !important;\n    background-color: var(--white);\n\n    button {\n        font-size: 13px;\n        font-weight: 500;\n        line-height: 33px;\n        height: 33px;\n        margin-top: 5px;\n        padding: 5px 10px;\n        border-radius: 5px;\n        transition: all .5s linear;\n        box-shadow: none !important;\n        background: transparent !important;\n        color: #07748f;\n        border: none !important;\n        text-transform: capitalize;\n        justify-content: flex-start !important;\n\n        span {\n            font-size: 16px;\n            margin-right: 5px;\n        }\n\n        &:hover {\n            background-color: var(--primary) !important;\n            color: var(--white);\n        }\n    }\n}\n\n.MuiPaper-elevation.MuiMenu-paper {\n    max-height: 250px !important;\n    max-width: 280px !important;\n\n    ul {\n        li {\n            font-size: 12px;\n            padding: 2px 10px;\n            font-weight: 500;\n\n            em {\n                font-style: normal !important;\n            }\n        }\n    }\n}\n\n/*-- Table --*/\n.MuiTablePagination-selectLabel,\n.MuiTablePagination-displayedRows {\n    margin-bottom: 0px;\n}\n\n#webpack-dev-server-client-overlay {\n    display: none !important;\n}\n\n.scrolling-text-container {\n    width: 100%;\n    overflow: hidden;\n    white-space: nowrap;\n    height: 40px;\n    display: flex;\n    align-items: center;\n}\n\n.ac-status-bar {\n    animation: scrollText 25s linear infinite;\n}\n\n@keyframes scrollText {\n    0% {\n        transform: translateX(185%);\n    }\n\n    100% {\n        transform: translateX(-100%);\n    }\n}\n\n/* Add this to your CSS or use a CSS-in-JS solution like styled-components */\n.toggle-switch {\n    display: inline-block;\n    position: relative;\n    width: 34px;\n    height: 18px;\n}\n\n.toggle-switch input {\n    display: none;\n}\n\n.yesorno {\n    color: #7b7b7b;\n    font-weight: 400;\n    position: relative;\n    top: -3px;\n    font-size: 13px;\n    padding-left: 10px;\n}\n\n.slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #888;\n    transition: 0.4s;\n    border-radius: 30px;\n}\n\n.slider:before {\n    position: absolute;\n    content: '';\n    height: 14px;\n    width: 14px;\n    left: 2px;\n    bottom: 2px;\n    background-color: white;\n    transition: 0.4s;\n    border-radius: 50%;\n}\n\ninput[type=\"checkbox\"].custom-checkbox,\ninput[type=\"checkbox\"] {\n    width: 16px;\n    height: 16px;\n    background-image: url(\"./assets/images/unchecked.webp\") !important;\n    background-size: contain;\n    background-repeat: no-repeat;\n    outline: none !important;\n    cursor: pointer !important;\n    border: none;\n    appearance: none;\n    /* Remove default checkbox appearance */\n}\n\ninput[type=\"checkbox\"].custom-checkbox:checked,\ninput[type=\"checkbox\"]:checked {\n    background-image: url(\"./assets/images/checked.webp\") !important;\n    background-size: contain;\n    background-repeat: no-repeat;\n    cursor: pointer !important;\n}\n\ninput:checked+.slider {\n    background-color: var(--primary);\n}\n\ninput:checked+.slider:before {\n    transform: translateX(17px);\n}\n\n.spin {\n    animation-name: spin;\n    animation-duration: 4000ms;\n    animation-iteration-count: infinite;\n    animation-timing-function: linear;\n}\n\nbutton.loginbtn {\n    align-items: center;\n    display: flex !important;\n\n    svg {\n        margin-right: 5px;\n    }\n\n    &:disabled {\n        opacity: 1 !important;\n    }\n}\n\n.stepper-btn {\n    button.secondary_button.clear-background {\n        background: $transparent !important;\n        color: #313232 !important;\n        border: $px-1 solid #313232 !important;\n        margin-right: $px-15 !important;\n\n        &:hover,\n        &:active,\n        &:focus {\n            color: #fff !important;\n            background-color: #545b62 !important;\n            border-color: #4e555b !important;\n        }\n    }\n}\n\nbutton:disabled {\n    opacity: 0.6;\n}\n\n// Side menu css //\n\n.css-12i7wg6-MuiPaper-root-MuiDrawer-paper {\n    z-index: 2 !important;\n}\n\n// error text \n.no-data-availabe {\n    color: #f15d48 !important;\n    font-size: 13px;\n}\n\n.err-txt {\n    font-size: 11px !important;\n    font-weight: 400 !important;\n    line-height: 1.66 !important;\n    color: red !important;\n}\n\n.color-red {\n    color: red;\n}\n\n// input box common\n.input-common {\n    display: block;\n    width: 100%;\n    height: calc(1.5em + 0.75rem + 2px);\n    padding: 0.375rem 0.75rem;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #495057;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid #ced4da;\n    border-radius: 0.25rem;\n    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n}\n\ninput::placeholder {\n    font-size: 12px !important;\n    color: currentColor;\n    opacity: 1;\n}\n\n// Resume Play button \n#play-btns {\n    background: #5a6e82 !important;\n    color: #fff !important;\n    font-size: 10px !important;\n    padding: 4px 5px !important;\n\n    img {\n        margin-right: 6px;\n    }\n\n    span {\n        position: relative;\n        top: 1px;\n    }\n}\n\ninput[type=\"time\"] {\n    position: relative;\n}\n\ninput[type=\"time\"]::-webkit-calendar-picker-indicator {\n    display: block;\n    top: 0;\n    right: 0;\n    height: 100%;\n    width: 100%;\n    position: absolute;\n    background: transparent;\n}\n\n.MuiPopper-root[role=\"dialog\"],\n.base-Popper-root[role=\"dialog\"] {\n    max-width: 113px !important;\n    display: inline-block;\n    position: relative;\n    outline: none;\n    list-style: none;\n    font-size: 12px;\n    text-align: left;\n    background-color: #fff;\n    border-radius: 4px;\n    box-shadow: 0 1px 5px #ccc;\n    background-clip: padding-box;\n    border: 1px solid #ccc;\n    line-height: 1.5;\n\n    .MuiPickersLayout-contentWrapper {\n        .MuiMultiSectionDigitalClock-root {\n\n            ul {\n                float: left;\n                font-size: 12px;\n                border: 1px solid #e9e9e9;\n                border-width: 0 1px;\n                margin-left: -1px;\n                box-sizing: border-box;\n                width: 56px;\n                max-height: 170px;\n                overflow-y: auto;\n                position: relative;\n\n                li {\n                    padding-left: 0px !important;\n                    padding-right: 0px !important;\n                    width: 100% !important;\n                    margin: 0px !important;\n                    height: 24px !important;\n\n                    &:hover {\n                        background-color: hsl(210, 77%, 46%) !important;\n                        color: #fff !important;\n                    }\n                }\n\n                .Mui-selected {\n                    background-color: rgb(217 226 229) !important;\n                    color: #384648 !important;\n                    font-weight: 700;\n                }\n\n                &::after {\n                    height: fit-content !important;\n                }\n            }\n        }\n    }\n\n    .MuiPickersLayout-actionBar {\n        display: none;\n    }\n}\n\n.input-time-picker {\n\n    input,\n    button,\n    fieldset {\n        display: none !important;\n    }\n}\n\nbutton.MuiButtonBase-root span.MuiTouchRipple-root {\n    display: none !important;\n}\n\n//Scroll\n.MuiMenu-root.MuiPopover-root[id=\"menu-\"] {\n    .MuiPaper-elevation.MuiMenu-paper::-webkit-scrollbar {\n        width: 4px;\n    }\n\n    .MuiPaper-elevation.MuiMenu-paper::-webkit-scrollbar-track {\n        background: #ff924e38;\n    }\n\n    .MuiPaper-elevation.MuiMenu-paper::-webkit-scrollbar-thumb {\n        background: #07748F;\n    }\n\n    .MuiPaper-elevation.MuiMenu-paper::-webkit-scrollbar-thumb:hover {\n        background: #07748F;\n        cursor: pointer;\n    }\n}\n\n/*--other common classnames--*/\n.extraction-cls {\n    cursor: pointer;\n    color: blue;\n}\n\n.view-shop-table-class {\n    overflow-x: auto;\n    max-height: 400px;\n    margin: auto;\n    width: 50vw;\n}\n\n.max-height-table {\n    overflow-y: scroll;\n    max-height: 400px;\n}\n\n.grey-clr {\n    color: #5a6e7f;\n}\n\nbutton,\na {\n    cursor: pointer !important;\n}\n\ndiv[style=\"opacity: 1; transform: none; transition: opacity 271ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 180ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\"] {\n    transition: none !important;\n}\n\n.Mui-selected {\n    background-color: rgb(217 226 229) !important;\n    color: #384648 !important;\n}\n\n.name-check {\n    display: flex;\n    align-items: center;\n    width: 100%;\n\n    span {\n        padding-top: 2px !important;\n        padding-right: 3px !important;\n        padding-bottom: 0px !important;\n        top: 2px !important;\n    }\n\n    .check-dots {\n        font-size: 20px !important;\n        width: 70%;\n        height: 30px !important;\n        text-align: center !important;\n        font-weight: 400 !important;\n        color: #000000 !important;\n    }\n}\n\n.shopname-tooltip-btn {\n    color: #000000 !important;\n    text-decoration: $none;\n    background-color: $transparent;\n    font-size: $px-14 !important;\n    word-break: break-all;\n    font-weight: 400 !important;\n    text-transform: none !important;\n}\n\n#dashboardmenulist {\n    .MuiTooltip-tooltip {\n        opacity: 1;\n    }\n}\n\n#shopdetailstooltip,\n#dashboardmenulist {\n    z-index: 1299 !important;\n\n    .MuiTooltip-tooltip {\n        width: 100% !important;\n        max-width: $per-100;\n        background: transparent;\n        margin: 0px !important;\n    }\n}\n\n.Shop-details {\n    display: block !important;\n}\n\n\n.Shop-details {\n    min-height: fit-content !important;\n    box-shadow: 0px 4px 4px 0px #00000040 !important;\n    border: 1px solid #D9E2E5;\n    border-radius: 8px !important;\n    width: 320px;\n    background-color: #fff;\n    padding: 10px;\n\n    li {\n        font-size: 12px !important;\n        color: #000000DE;\n        z-index: -1;\n        display: flex;\n\n        span {\n            width: 50%;\n        }\n\n        .callcount-value {\n            overflow: visible;\n        }\n\n        .callcount-unavailable-row {\n            display: flex;\n            align-items: center;\n            gap: 6px;\n            width: auto;\n        }\n\n        .callcount-unavailable-text {\n            color: #d32f2f;\n            width: 90px;\n        }\n\n        .callcount-retry-btn {\n            flex-shrink: 0;\n            width: auto;\n            color: #1976d2;\n            cursor: pointer;\n            text-decoration: underline;\n            font-weight: 600;\n            font-size: 11px;\n            white-space: nowrap;\n\n            &.retrying {\n                opacity: 0.6;\n                pointer-events: none;\n            }\n        }\n    }\n\n    button {\n        width: 100%;\n        padding: 8px !important;\n        border-radius: 8px !important;\n        margin-top: 8px !important;\n        font-size: 12px !important;\n        text-transform: capitalize !important;\n        font-weight: 600 !important;\n        color: #2E3D40 !important;\n\n    }\n\n    .log-btn {\n        background-color: #E4EAEB !important;\n        border: 1px solid #A0B2B5 !important;\n    }\n\n    .edit-btn {\n        background-color: #A6C4CB !important;\n        border: 1px solid #055061 !important;\n    }\n}\n\n.backgroundchange {\n    li {\n        &:hover {\n            background-color: #D9E2E5 !important;\n            color: #000 !important;\n\n            img {\n                filter: brightness(0) !important;\n            }\n        }\n    }\n}\n\n.action-btns-box {\n    max-height: 13rem !important;\n    min-height: fit-content !important;\n    box-shadow: 0px 4px 4px 0px #00000040 !important;\n    border: 1px solid #D9E2E5;\n    border-radius: 8px !important;\n    background-color: #fff;\n\n    li {\n        font-size: 12px !important;\n        color: #000000DE;\n        z-index: 2;\n        position: relative;\n\n        img {\n            margin-right: 5px;\n            width: 14px;\n        }\n\n        &:hover {\n            background-color: rgba(0, 0, 0, 0.04);\n            color: rgba(0, 0, 0, 0.8705882353);\n            border-radius: 8px !important;\n\n            img {\n                filter: brightness(0);\n            }\n        }\n    }\n\n}\n\n.dot-check,\n.shop-info {\n    position: relative;\n\n    .action-btns-box {\n        display: block;\n        position: relative;\n        z-index: 1;\n    }\n\n    .active-action-btns-box {\n        display: block;\n\n    }\n}\n\n.MuiDrawer-paperAnchorDockedLeft {\n    z-index: 2 !important;\n}\n\nsvg.minus-svg {\n    width: 16px;\n    margin-right: 3px;\n    color: #2E3D40;\n    height: 18px;\n}\n\n.flex-box-button {\n    display: flex;\n    align-items: center;\n\n    button {\n        padding: 6px 10px;\n        border-radius: 4px;\n        background-color: var(--primary);\n        color: #fff;\n        margin-left: 10px;\n    }\n}\n\nspan.no-options-found {\n    font-size: 12px;\n    padding: 2px 10px 0px;\n    font-weight: 500;\n}\n\n.libraryerror {\n    text-align: center;\n    margin-top: 20px;\n    font-size: 14px;\n    color: var(--primary);\n}\n\n.name-check span.align-item-cs {\n    position: relative;\n    top: -5px !important;\n}\n\n#menu-outputtype.MuiMenu-root,\n#menu-pos.MuiMenu-root,\n#menu-currency.MuiMenu-root,\n.date-field-css,\n#menu-source.MuiMenu-root,\n#menu-routetype.MuiMenu-root,\n#menu-status.MuiMenu-root,\n#menu-group.MuiMenu-root,\n#menu-cabinclass.MuiMenu-root {\n    cursor: pointer !important;\n}\n\n.MuiOutlinedInput-notchedOutline {\n    border: 0px solid #F4F6F7 !important;\n}\n\n.dontselect {\n    pointer-events: none;\n}\n\n.overhidden {\n\n    overflow: visible !important;\n}\n\n.customwidthrestrick {\n    width: initial !important;\n}\n\n.passwordshow {\n    position: relative;\n\n    input {\n        position: relative;\n        z-index: 1;\n        padding: 6px 28px 6px 6px;\n    }\n\n    span.visibleeye {\n        cursor: pointer;\n        display: inline-block;\n        overflow: hidden;\n        text-align: center;\n        position: absolute;\n        z-index: 1;\n        top: 7px;\n        right: 10px;\n        color: var(--lowgray) !important;\n\n        svg {\n            font-size: 16px;\n        }\n    }\n}\n\n.indiana-scroll-container {\n    overflow-y: hidden;\n    scroll-behavior: smooth;\n\n    /* width */\n    &::-webkit-scrollbar {\n        width: 5px;\n        height: 5px;\n        cursor: pointer;\n    }\n\n    /* Track */\n    &::-webkit-scrollbar-track {\n        background: #ffffff;\n        cursor: pointer;\n    }\n\n    /* Handle */\n    &::-webkit-scrollbar-thumb {\n        background: #A0B2B5;\n        cursor: pointer;\n    }\n\n    /* Handle on hover */\n    &::-webkit-scrollbar-thumb:hover {\n        background: #A0B2B5;\n    }\n}\n\n.reset-pass {\n    p {\n        display: flex;\n        align-items: center;\n\n        svg {\n            margin-right: 3px;\n            width: 18px;\n            height: 18px;\n        }\n    }\n}\n\n.icons-svg-cs {\n    width: 12px !important;\n    height: 12px !important;\n    margin-left: 5px;\n    cursor: pointer;\n}\n\n#tableau-viz iframe {\n    overflow-clip-margin: content-box !important;\n    overflow: clip !important;\n}\n\n#tableau-viz,\n#tableau-viz:hover,\n#tableau-viz iframe,\n#tableau-viz iframe:hover {\n    overflow-y: hidden !important;\n    overflow-x: hidden !important;\n    justify-content: center !important;\n}\n\n#tableau-viz::-webkit-scrollbar,\n#tableau-viz iframe::-webkit-scrollbar {\n    width: 0px;\n    height: 0px;\n}\n\n/* Track */\n#tableau-viz::-webkit-scrollbar,\n#tableau-viz iframe::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 5px rgb(255, 255, 255);\n    border-radius: 0px;\n}\n\n/* Handle */\n#tableau-viz::-webkit-scrollbar,\n#tableau-viz iframe::-webkit-scrollbar-thumb {\n    background: red;\n    border-radius: 10px;\n}\n\n/* Handle on hover */\n#tableau-viz::-webkit-scrollbar,\n#tableau-viz iframe::-webkit-scrollbar-thumb:hover {\n    background: #b30000;\n}\n\n.disabled-actions {\n    pointer-events: none !important;\n}\n\n.required-modal {\n    .create-dashboard-modal {\n        width: 35% !important;\n\n        .dashboard-review-details {\n            padding: 8px 0px 16px !important;\n        }\n\n        .dashboard-review-table {\n            min-height: 330px;\n            max-height: 330px;\n            overflow: auto;\n\n            th {\n                border: none !important;\n            }\n\n            th:nth-child(1) {\n                width: 25% !important;\n            }\n\n            th:nth-child(2) {\n                width: 20% !important;\n            }\n\n            th:nth-child(3) {\n                width: 30% !important;\n            }\n\n\n            &::-webkit-scrollbar {\n                width: 7px;\n            }\n\n            &::-webkit-scrollbar-track {\n                background: #ffffff;\n                border-radius: 5px;\n                border: 1px solid #D9E2E5;\n                padding: 0px 5px;\n            }\n\n            &::-webkit-scrollbar-thumb {\n                border-radius: 5px;\n                background: #9b9a9a;\n            }\n\n            &::-webkit-scrollbar-thumb:hover {\n                background: #999;\n            }\n        }\n\n        .required-select {\n            border: 2px solid rgba(0, 0, 0, 0.12);\n            border-radius: 4px;\n            margin: 0px 5px;\n            padding: 3px 0px;\n            width: fit-content;\n        }\n    }\n}\n\n.create-dashboard-modal {\n    width: 922px !important;\n\n    input[type=\"text\"] {\n        width: 100%;\n        height: 30px;\n        line-height: 30px;\n        opacity: 0.8;\n        padding-right: 0.5rem;\n        border: 1px solid #F4F6F7;\n        border-radius: 8px !important;\n        background-color: #F4F6F7 !important;\n        background-repeat: no-repeat;\n        background-position: 0;\n        padding-left: 30px;\n        background-size: 26px;\n        margin-bottom: 15px;\n    }\n\n    h3 {\n        margin-bottom: 0px !important;\n        font-size: 16px !important;\n        font-weight: 600 !important;\n    }\n\n    h4,\n    h5 {\n        margin-bottom: 8px !important;\n        font-size: 14px !important;\n        font-weight: 600;\n        color: #1C1C1C;\n        opacity: 0.5 !important;\n    }\n\n    .modal-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center !important;\n        margin-bottom: 5px;\n\n        button {\n            line-height: normal;\n            padding: 0px;\n            height: fit-content;\n            min-width: fit-content;\n            font-size: 25px;\n            transform: rotate(45deg);\n            &:hover {\n                background-color: transparent !important;\n            }\n        }\n    }\n\n    .add-dashboard-form {\n        width: 100%;\n\n        .library-list {\n            height: 150px;\n            overflow-y: auto;\n            border: 1px solid #D9E2E5;\n            border-radius: 8px;\n            padding: 10px !important;\n            background-color: #f6f8f9;\n            margin-bottom: 0px;\n\n            &::-webkit-scrollbar {\n                width: 7px;\n            }\n\n            &::-webkit-scrollbar-track {\n                background: #ffffff;\n                border-radius: 5px;\n                border: 1px solid #D9E2E5;\n                padding: 0px 5px;\n            }\n\n            &::-webkit-scrollbar-thumb {\n                border-radius: 5px;\n                background: #9b9a9a;\n            }\n\n            &::-webkit-scrollbar-thumb:hover {\n                background: #999;\n            }\n\n            .w-200 {\n                width: 16.5% !important;\n            }\n\n            .pagination-page {\n                padding: 0px 8px !important;\n            }\n\n            ul {\n                li {\n                    list-style: none;\n\n                    label {\n                        font-size: 14px;\n                        cursor: pointer;\n                    }\n                }\n            }\n        }\n    }\n\n    .group-submit-btn {\n        background-color: #FFA26E !important;\n        border: 1px solid #FFA26E !important;\n        outline: none !important;\n        font-size: 14px;\n        font-weight: 700;\n        width: 100%;\n        padding: 4px 8px;\n        border-radius: 8px;\n        color: #fff;\n        margin-top: 10px;\n    }\n}\n\n.center-success-modal {\n    .modal-box {\n        margin-top: auto !important;\n        width: 450px !important;\n        height: 235px !important;\n        text-align: center;\n        border-radius: 30px;\n    }\n\n    h3 {\n        text-align: center;\n        font-size: 24px !important;\n        font-weight: 600;\n        color: var(--info);\n    }\n\n    p {\n        text-align: center !important;\n        margin-top: 20px;\n        margin-bottom: 20px;\n        color: var(--info);\n    }\n\n    .away-btn {\n        cursor: pointer;\n        background-color: transparent;\n        font-size: 14px;\n\n        &:hover,\n        &:focus,\n        &:active {\n            background-color: transparent;\n            font-size: 14px;\n        }\n    }\n}\n\n.icon-thunder {\n    height: 21px;\n    position: relative;\n    top: 3px;\n}\n\n.btn-donload-reports {\n    border-radius: 5px !important;\n    margin-left: 10px;\n    font-size: 13px !important;\n    border: 3px solid var(--primary) !important;\n    background-color: var(--primary) !important;\n    color: var(--white) !important;\n    box-shadow: none !important;\n    padding: 14px 30px !important;\n    position: relative !important;\n    transition: all 0.5s linear !important;\n    text-align: center !important;\n    vertical-align: middle !important;\n    text-decoration: none !important;\n    outline: 0px !important;\n    font-weight: 600 !important;\n    line-height: 0px !important;\n    cursor: pointer !important;\n    text-transform: capitalize !important;\n}\n\n.disabled-btn-pointer {\n    opacity: 0.7;\n    cursor: not-allowed !important;\n}\n\n.disabled-btn-pointer:disabled {\n    cursor: not-allowed !important;\n}\n\nbutton.hidedots {\n    display: none !important;\n}\n\n.add-swap-btn {\n    background: #07748F;\n    text-transform: none;\n    padding: 0 30px;\n    font-weight: 400;\n    font-size: 14px;\n    border: none;\n    border-radius: 2px;\n    height: 35px;\n    line-height: 35px;\n    box-shadow: none !important;\n    transition: all .5s linear;\n    margin-right: 17px !important;\n}\n\n#seeoverview {\n    flex-direction: row;\n    align-items: center;\n\n    .tableau-dropdown {\n        width: 350px !important;\n        border: none !important;\n        margin-right: 15px !important;\n        padding: 0px !important;\n        min-height: fit-content !important;\n        max-height: fit-content !important;\n        height: fit-content;\n    }\n}\n\n.see-link {\n    font-size: 14px;\n    font-weight: 400;\n    text-decoration: underline;\n    color: var(--secondary);\n    cursor: pointer;\n    width: fit-content !important;\n}\n\n.custom-select__option--is-focused {\n    background-color: #fff2eb !important;\n}\n\n.custom-select__option--is-selected {\n    background-color: #FFA26E !important;\n    color: white;\n}\n\n.custom-select__control--is-focused {\n    border-color: transparent !important;\n}\n\n\n.custom-select__control--is-focused {\n    border-color: transparent !important;\n    /* Remove the border when focused */\n    box-shadow: 0 0 0 1px !important;\n    /* Remove the shadow effect when focused */\n}\n\n.dropdown-menu {\n    color: #fff;\n    cursor: pointer;\n    position: relative;\n    text-align: center;\n    text-decoration: none;\n    z-index: 1;\n    transform: perspective(1000px);\n}\n\n.dropdown-menu-item {\n    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2509803922) !important;\n    border: 1px solid #D9E2E5;\n    border-radius: 8px !important;\n    background-color: #fff;\n    list-style-type: none;\n    margin: 0;\n    opacity: 1;\n    visibility: visible;\n    padding: 5px 10px;\n    cursor: pointer;\n    -webkit-transition: all .5s, background, 2s .5s linear;\n    transition: all .5s, background 2s .5s linear;\n}\n\n.dropdown-menu-item li {\n    cursor: pointer;\n    padding: 4px 0px;\n\n    label {\n        display: flex;\n        align-items: center;\n        color: rgba(0, 0, 0, 0.8705882353) !important;\n\n        input {\n            margin-right: 5px;\n        }\n    }\n\n    &:hover {\n        background-color: transparent !important;\n        color: rgba(0, 0, 0, 0.8705882353) !important;\n    }\n}\n\n.dropdown-menu:hover .dropdown-menu-item {\n    opacity: 1;\n    visibility: visible;\n    padding: 5px 10px;\n    cursor: pointer;\n    -webkit-transition: all .5s, background, 2s .5s linear;\n    transition: all .5s, background 2s .5s linear;\n}\n\n.menu-center {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    span {\n        display: flex;\n        align-items: center;\n        cursor: pointer;\n\n        img {\n            margin-right: 5px !important;\n        }\n    }\n\n    img {\n        margin-right: 0px !important;\n    }\n\n    .scroll-list {\n        max-height: 200px;\n        overflow: auto;\n        cursor: pointer;\n\n        &::-webkit-scrollbar {\n            width: 4px;\n        }\n\n        /* Track */\n        &::-webkit-scrollbar-track {\n            background: #404040;\n        }\n\n        /* Handle */\n        &::-webkit-scrollbar-thumb {\n            background: #FF914E;\n        }\n\n        /* Handle on hover */\n        &::-webkit-scrollbar-thumb:hover {\n            background: #FF914E;\n        }\n    }\n\n    button {\n        background-color: var(--primary);\n        color: #fff !important;\n        padding: 4px 13px;\n        font-size: 11px;\n        margin-top: 10px;\n        cursor: pointer;\n        width: 100%;\n\n        &:hover {\n            background-color: var(--primary);\n        }\n    }\n}\n\n.img-arrow-dashboard {\n    width: 8px !important;\n}\n\n.child-loader {\n    position: relative;\n}\n\n.text-none {\n    text-transform: none !important;\n}\n\n.reviewTable-accordion {\n    box-shadow: unset;\n    border: none;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n    border-radius: 0px !important;\n    margin-top: 0px !important;\n\n    &::before {\n        background-color: transparent !important;\n        height: 0px !important;\n    }\n\n    .Mui-expanded.MuiAccordionSummary-gutters {\n        border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n        min-height: 48px !important;\n    }\n\n    .MuiAccordionSummary-content {\n        margin: 12px 0px !important;\n    }\n\n}\n\n.alerts-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    text-align: center;\n    button{\n        background-color: transparent !important;\n    }\n  }\n  \n  ","/*--Fonts--*/\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');\n\n:root {\n  --primary: #FF914E;\n  --secondary: #07748F;\n  --info: #343833;\n  --white: #FFFFFF;\n  --black: #000000;\n  --liteblue: #e7f3f5;\n  --shadeblue: #d1e6eb;\n  --hrborder: #e4dede;\n  --theader: #f5f7f8;\n  --thinfo: #384648;\n  --thborder: #dee2e6;\n  --dlink: #007bff;\n  --btninfo: #313232;\n  --gary: #5a6e82;\n  --high-to-low: linear-gradient(to right, #07748F 0%, #72B0C0 100%);\n  --low-to-high: linear-gradient(90deg, #72B0C0 0, #07748F);\n  --red: #f15e48;\n  --green: #02681a;\n  --lowgray: #A0B2B5;\n}\n\n/* ---- font family ----*/\n$montserrat : 'Montserrat';\n$roboto: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n\n/*--- pixels --- */\n$px-0: 0px;\n$px-1: 1px;\n$px-2: 2px;\n$px-3: 3px;\n$px-4: 4px;\n$px-5: 5px;\n$px-6: 6px;\n$px-7: 7px;\n$px-8: 8px;\n$px-9: 9px;\n$px-10: 10px;\n$px-11: 11px;\n$px--11: -11px;\n$px-12: 12px;\n$px-13: 13px;\n$px-14: 14px;\n$px-15: 15px;\n$px-16: 16px;\n$px-17: 17px;\n$px-18: 18px;\n$px-19: 19px;\n$px-20: 20px;\n$px-21: 21px;\n$px-22: 22px;\n$px-23: 23px;\n$px-24: 24px;\n$px-25: 25px;\n$px-26: 26px;\n$px-27: 27px;\n$px-28: 28px;\n$px-29: 29px;\n$px-30: 30px;\n$px-31: 31px;\n$px-32: 32px;\n$px-33: 33px;\n$px-34: 34px;\n$px-35: 35px;\n$px-36: 36px;\n$px-37: 37px;\n$px-38: 38px;\n$px-39: 39px;\n$px-40: 40px;\n$px-41: 41px;\n$px-42: 42px;\n$px-43: 43px;\n$px-44: 44px;\n$px-45: 45px;\n$px-46: 46px;\n$px-47: 47px;\n$px-48: 48px;\n$px-49: 49px;\n$px-50: 50px;\n$px-51: 51px;\n$px-52: 52px;\n$px-53: 53px;\n$px-54: 54px;\n$px-55: 55px;\n$px-56: 56px;\n$px-57: 57px;\n$px-58: 58px;\n$px-59: 59px;\n$px-60: 60px;\n$px-61: 61px;\n$px-62: 62px;\n$px-63: 63px;\n$px-64: 64px;\n$px-65: 65px;\n$px-70: 70px;\n$px-74: 74px;\n$px-75: 75px;\n$px-80: 80px;\n$px-85: 85px;\n$px-100: 100px;\n$px-115: 115px;\n$px-120: 120px;\n$px-124: 124px;\n$px-130: 130px;\n$px-150: 150px;\n$px-200: 200px;\n$px-226: 226px;\n$px-250: 250px;\n$px-280: 280px;\n$px-300: 300px;\n$px-585: 585px;\n\n/*---font size---*/\n$f-10: $px-10;\n$f-11: $px-11;\n$f-12: $px-12;\n$f-13: $px-13;\n$f-14: $px-14;\n$f-15: $px-15;\n$f-16: $px-16;\n$f-17: $px-17;\n$f-18: $px-18;\n$f-19: $px-19;\n$f-20: $px-20;\n$f-21: $px-21;\n$f-22: $px-22;\n$f-23: $px-23;\n$f-24: $px-24;\n$f-25: $px-25;\n$f-26: $px-26;\n$f-27: $px-27;\n$f-28: $px-28;\n$f-29: $px-29;\n$f-30: $px-30;\n$f-31: $px-31;\n$f-32: $px-32;\n$f-33: $px-33;\n$f-34: $px-34;\n$f-35: $px-35;\n$f-36: $px-36;\n$f-37: $px-37;\n$f-38: $px-38;\n$f-39: $px-39;\n$f-40: $px-40;\n$f-41: $px-41;\n$f-42: $px-42;\n$f-43: $px-43;\n$f-46: $px-46;\n\n/*---font weight---*/\n$f-300: 300;\n$f-400: 400;\n$f-500: 500;\n$f-600: 600;\n$f-700: 700;\n$f-800: 800;\n$f-900: 900;\n\n/*--- percentage ---*/\n$per-8: 8%;\n$per-10: 10%;\n$per-18: 18%;\n$per-30: 30%;\n$per-35: 35%;\n$per-38: 38%;\n$per-40: 40%;\n$per-45: 45%;\n$per-48: 48%;\n$per-50: 50%;\n$per-55: 55%;\n$per-60: 60%;\n$per-85: 85%;\n$per-90: 90%;\n$per-91: 91%;\n$per-100: 100%;\n$per-200: 200%;\n\n/*--- display ---*/\n$flex: flex;\n$block: block;\n$grid: grid;\n$auto: auto;\n$inlineblock: inline-block;\n$row: row;\n$none: none;\n$max-content: max-content;\n$transparent: transparent;\n$no-repeat: no-repeat;\n\n/*--- alignment ---*/\n$top: top;\n$left: left;\n$center: center;\n$right: right;\n$bottom: bottom;\n$middle: middle;\n$space-between: space-between;\n$column: column;\n$breakword: break-word;\n$borderbox: border-box;\n$end: end;\n\n/*--Position --*/\n$relative: relative;\n$absolute: absolute;\n$initial: initial;\n\n/*--- Text Transform ---*/\n$uppercase: uppercase;\n$lowercase: lowercase;\n$capitalize: capitalize;\n$underline: underline;\n\n/*-- Text Style --*/\n$normal: normal;\n\n/*-- Info and paragraph --*/\n.font-common {\n  font-size: $f-14;\n  color: var(--info);\n  font-weight: $f-600;\n}\n\n/*--Flex-box--*/\n.w-flex {\n  width: $per-100;\n  display: $flex;\n}\n\n/*-- Form Label--*/\n.input-fonts {\n  font-size: $f-11;\n  color: var(--black);\n}\n\n.formlabel {\n  @extend .input-fonts;\n  opacity: 1;\n  margin-bottom: 0.3rem;\n  margin-top: $px-5;\n  font-weight: $f-500;\n}\n\n.login-btn-hover {\n  color: var(--primary);\n  background-position: $left;\n  fill: var(--primary) !important;\n}\n\n.heading-comman {\n  font-style: $normal;\n  font-weight: 700;\n}\n\n.heading-1 {\n  font-size: $f-43;\n  line-height: $px-62;\n  margin-bottom: $px-25;\n  @extend .heading-comman;\n}\n\n.heading-2 {\n  font-size: $f-35;\n  line-height: $px-50;\n  @extend .heading-comman;\n}\n\n.heading-3 {\n  font-size: $f-30;\n  line-height: $px-60;\n  margin-bottom: $px-15;\n  @extend .heading-comman;\n}\n\n.heading-4 {\n  font-weight: 600;\n  font-size: 25px;\n  line-height: 26px;\n  @extend .heading-comman;\n}\n\n.inputfields {\n  @extend .input-fonts;\n  height: $px-30;\n  line-height: $px-30;\n  opacity: .8;\n  padding: $px-0 0.5rem;\n  background: #F4F6F7;\n}\n\n/*-- Box outer --*/\n.boxing {\n  position: $relative;\n  display: $flex;\n  flex-direction: $column;\n  min-width: 0;\n  word-wrap: $breakword;\n  background-color: var(--white);\n  background-clip: $borderbox;\n  border: $px-1 solid rgba(0, 0, 0, .125);\n  border-radius: 0.25rem;\n  box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075);\n  padding: $px-15 $px-15;\n}\n\n.login-btn-hover {\n  color: var(--primary);\n  background-position: $left;\n  fill: var(--primary) !important;\n}\n\n.heading-comman {\n  font-style: $normal;\n  font-weight: 700;\n}\n\n.heading-1 {\n  font-size: $f-43;\n  line-height: $px-62;\n  margin-bottom: $px-25;\n  @extend .heading-comman;\n}\n\n.heading-2 {\n  font-size: $f-35;\n  line-height: $px-50;\n  @extend .heading-comman;\n}\n\n.heading-3 {\n  font-size: $f-30;\n  line-height: $px-60;\n  margin-bottom: $px-15;\n  @extend .heading-comman;\n}\n\n/*--Buttons common--*/\n.button-common {\n  background: $transparent  !important;\n  display: $inlineblock  !important;\n  padding: $px-8 $px-30  !important;\n  height: $px-44  !important;\n  border-radius: $px-50  !important;\n  position: $relative  !important;\n  transition: all .5s linear !important;\n  text-align: $center  !important;\n  vertical-align: $middle  !important;\n  text-decoration: $none  !important;\n  outline: $px-0  !important;\n  font-size: $f-16  !important;\n  font-weight: $f-600  !important;\n  line-height: $px-0  !important;\n  cursor: pointer !important;\n  text-transform: $capitalize  !important;\n}\n\n.link_button {\n  padding: $px-8 $px-40  !important;\n  line-height: 1.5 !important;\n  height: fit-content !important;\n}\n\n.primary {\n  border: $px-3 solid var(--primary) !important;\n  background-color: var(--primary) !important;\n  color: var(--white) !important;\n  box-shadow: none!important;\n}\n\n.secondary {\n  border: $px-3 solid var(--primary) !important;\n  background-color: var(--primary) !important;\n  color: var(--white) !important;\n  box-shadow: none!important;\n}\n.stepper-next-btn:hover {\n  border: 0px !important;\n}\n\n.primary_button {\n  @extend .button-common;\n  @extend .primary;\n\n  &:hover {\n    @extend .secondary;\n  }\n\n  span.MuiTouchRipple-root {\n    display: none;\n  }\n}\n\n.secondary_button {\n  @extend .button-common;\n  @extend .secondary;\n\n  &:hover {\n    @extend .primary;\n  }\n\n  span.MuiTouchRipple-root {\n    display: none;\n  }\n}\n.seeanalytics {\n  padding: 8px 18px!important;\n  font-size: 13px!important;\n  font-weight: 500!important;\n  height: 33px!important;\n  &:hover, &:active, &:focus {\n    background-color: var(--primary)!important;\n  }\n}\n\n.btn-wid {\n  padding: 10px 40px !important;\n  margin-top: 25px;\n  margin-right: 13px;\n}\n\n/* --banner-style-- */\n.banner-bg-content {\n  .banner-container {\n    padding-top: $px-30;\n    padding-bottom: $px-30;\n    min-height: 585px;\n\n    .banner-content {\n      padding: $px-0;\n      color: var(--white);\n      font-style: $normal;\n\n      .smalltext {\n        font-weight: 600 !important;\n        line-height: 68px !important;\n        color: #07748f !important;\n        margin-bottom: 0 !important;\n        margin-top: 17px !important;\n        @extend .heading-2;\n      }\n\n      h1 {\n        @extend .heading-1;\n      }\n\n      p {\n        font-weight: $f-400;\n        font-size: $f-20;\n        line-height: $px-30;\n        margin-bottom: 1rem;\n      }\n    }\n\n    .banner-img {\n      img {\n        width: 119%;\n        position: $relative;\n        top: -$px-10;\n        left: 74px;\n        height: $auto;\n      }\n    }\n\n    .banner-btn {\n      a {\n        @extend .link_button;\n        box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, .3);\n\n        &:nth-child(2) {\n          background-color: $transparent  !important;\n          border: 2px solid var(--white) !important;\n        }\n\n        @extend .btn-wid;\n        @extend .primary_button;\n\n        &:hover {\n          box-shadow: $none;\n        }\n      }\n    }\n  }\n}\n\n/* -- card-style -- */\n.card-content {\n  background-color: rgba(7, 116, 143, .05);\n\n  h4 {\n    margin-bottom: $px-40;\n    @extend .heading-2;\n  }\n\n  .section-card {\n    width: $per-100;\n    margin-left: $auto;\n    display: $block;\n    height: 105px;\n    background: var(--white);\n    box-shadow: 0 4px 20px rgba(23, 125, 150, .2);\n    border-radius: $px-20;\n    padding: 10px 18px 10px 6px;\n    margin-bottom: $px-25;\n    transition: all .5s ease-in-out;\n    flex-direction: unset !important;\n\n    p {\n      font-style: normal;\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 22px;\n      margin-bottom: 0;\n      margin-left: 10px;\n    }\n\n    &:hover {\n      transform: scale(1.05);\n      box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, .3) !important;\n    }\n  }\n}\n\n  .btn-wid {\n    padding: 10px 40px !important;\n    margin-top: 25px;\n    margin-right: 13px;\n  }\n\n  /* --banner-style-- */\n  .banner-bg-content {\n    .banner-container {\n      padding-top: $px-30;\n      padding-bottom: $px-30;\n      min-height: 585px;\n\n      .banner-content {\n        padding: $px-0;\n        color: var(--white);\n        font-style: $normal;\n\n        .smalltext {\n          font-weight: 600 !important;\n          line-height: 68px !important;\n          color: #07748f !important;\n          margin-bottom: 0 !important;\n          margin-top: 17px !important;\n          @extend .heading-2;\n        }\n\n        h1 {\n          @extend .heading-1;\n        }\n\n        p {\n          font-weight: $f-400;\n          font-size: $f-20;\n          line-height: $px-30;\n          margin-bottom: 1rem;\n        }\n      }\n\n      .banner-img {\n        img {\n          width: 119%;\n          position: $relative;\n          top: -$px-10;\n          left: 74px;\n          height: $auto;\n        }\n      }\n\n      .banner-btn {\n        a {\n          @extend .link_button;\n          box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, .3);\n\n          &:nth-child(2) {\n            background-color: $transparent  !important;\n            border: 2px solid var(--white) !important;\n          }\n\n          @extend .btn-wid;\n          @extend .primary_button;\n\n          &:hover {\n            box-shadow: $none;\n          }\n        }\n      }\n    }\n  }\n\n  /* -- card-style -- */\n  .card-comman {\n    background: #fff;\n    box-shadow: 0 4px 40px rgba(0, 0, 0, .1);\n    border-radius: 20px;\n  }\n\n  .card-content {\n    background-color: rgba(7, 116, 143, .05);\n\n    h4 {\n      margin-bottom: $px-40;\n      @extend .heading-2;\n    }\n\n    .section-card {\n      width: $per-100;\n      margin-left: $auto;\n      display: $block;\n      height: 105px;\n      background: var(--white);\n      box-shadow: 0 4px 20px rgba(23, 125, 150, .2);\n      border-radius: $px-20;\n      padding: 10px 18px 10px 6px;\n      margin-bottom: $px-25;\n      transition: all .5s ease-in-out;\n      flex-direction: unset !important;\n\n      .h-op-features {\n        font-weight: 600 !important;\n        margin-bottom: 5px !important;\n      }\n\n      p {\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 22px;\n        margin-bottom: 0;\n        margin-left: 10px;\n      }\n\n      &:hover {\n        transform: scale(1.05);\n        box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, .3) !important;\n      }\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
